import common from './common'
import featuresPay from './feature'

const vi = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Sản phẩm/Biến thể",
        serialNumber: "Số Sê-ri",
        noProductsFound: "Không tìm thấy sản phẩm",
        searchByProductSku: "Tìm kiếm theo sản phẩm/SKU",
        searchSerialNumbers: "Tìm kiếm số sê-ri",
        transactionDetails: "Chi tiết Giao dịch",
        notAvailable: "Không có",
        mainWarehouse: "Kho Chính"
    },
    new_build_banner: {
        title: 'Phiên bản mới:',
        is_available: 'đã sẵn sàng',
        fallback_title: 'Đã có phiên bản mới của ứng dụng',
        desc: 'Làm mới để cập nhật các tính năng và cải tiến mới nhất.',
        refreshing: 'Đang làm mới…',
        refresh_now: 'Làm mới ngay',
        later: 'Để sau',
        you_are_on: "bạn đang ở"
    },
    short: {
        finance: 'Tài chính',
        stock: 'Kho hàng'
    },
    onboarding: {
        welcome: 'Chào mừng!',
        step: {
            product: {
                totalBreakdown: 'Bảng phân tích tổng thể',
                overallFulfilment: 'Hoàn thành tổng thể',
                totalShippedQty: 'Tổng số lượng đã giao',
                totalReceivedQty: 'Tổng số lượng đã nhận',
                totalOrderedQty: 'Tổng số lượng đã đặt',
                totalShippedOrdered: 'Tổng đã giao / đã đặt',
                totalReceivedOrdered: 'Tổng đã nhận / đã đặt',
                viewQty: 'Xem số lượng',
                fetchingQty: 'Đang tải chi tiết số lượng...',
                noStockInfo: 'Không tìm thấy thông tin tồn kho',
                title: 'Đã đạt 65%',
                description: 'Chỉ còn 2 bước nữa để bắt đầu thành công lớn của bạn!',
                Warehouse: "Kho",
            },
            stock: {
                title: 'Gần xong 95%!!',
                description: 'Chỉ còn một bước nữa để bắt đầu thành công lớn của bạn! Hoàn thành ngay bây giờ.'
            }
        },
        business: {
            title: 'Doanh nghiệp đã được tạo thành công!',
            description: 'Tuyệt vời! Doanh nghiệp của bạn đã được đăng ký'
        },
        product: {
            title: 'Thêm sản phẩm đầu tiên',
            description: 'Thêm sản phẩm để bắt đầu ghi nhận tồn kho',
            Warehouse: "Kho",
        },
        stock: {
            title: 'Thử thêm tồn kho',
            description: 'Bắt đầu ghi nhận hàng nhập và xuất kho'
        },
        action: {
            add_business: {
                title: 'Tạo doanh nghiệp',
                description: 'Muốn tạo doanh nghiệp mới? Nhấn vào đây'
            },
            join_business: {
                title: 'Tham gia doanh nghiệp',
                description: 'Có mã mời? Tham gia tại đây'
            }
        }
    },
    business: {
        title: 'Chọn doanh nghiệp, tạo mới hoặc tham gia',
        add_business: {
            title: 'Tạo doanh nghiệp mới',
            name: 'Tên doanh nghiệp',
            name_placeholder: 'Nhập tên',
            category: 'Ngành nghề kinh doanh',
            category_placeholder: 'Chọn ngành nghề',
            button: 'Tạo doanh nghiệp'
        },
        edit_business: {
            title: 'Sửa doanh nghiệp'
        },
        join_business: {
            title: 'Tham gia doanh nghiệp',
            input_code: 'Nhập mã mời bên dưới:',
            field_placeholder: 'Mã mời',
            confirm_title: 'Tham gia',
            confirm_text: 'Bạn sẽ trở thành thành viên của đội ngũ tại '
        },
        no_business: 'Không có doanh nghiệp nào',
        create_or_join: 'Tạo hoặc tham gia doanh nghiệp',
        message: {
            saved: 'Doanh nghiệp đã lưu thành công!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Giao dịch kho âm',
            isNegativeTransactionDisabledHint: 'Bằng cách bật tính năng này, bạn có thể ngăn chặn các giao dịch dẫn đến kho âm.',
            negativeStockError: 'Giao dịch kho âm đã bị vô hiệu hóa'
        }
    },
    profile: {
        edit_profile: {
            title: 'Sửa hồ sơ',
            name: 'Họ và tên',
            name_placeholder: 'Nhập họ và tên',
            email: 'Email',
            phone_number: 'Số điện thoại'
        },
        message: {
            required_name: 'Tên là bắt buộc'
        }
    },
    product: {
        weightedAverageCost: 'Giá vốn bình quân gia quyền',
        weightedAverageValueLabel: 'Giá trị bình quân gia quyền',
        Product: 'Sản phẩm',
        hideZeroStock: 'Ẩn hàng tồn kho bằng 0',
        allVariants: 'Tất cả biến thể',
        choose_product: 'Chọn sản phẩm',
        choose_product_empty: 'Chọn sản phẩm và nhập số lượng',
        choose_product_empty_manufacturing: 'Chọn sản phẩm và nhập số lượng sản xuất',
        search: {
            placeholder: 'Tìm theo tên',
            tooltip: 'Mở máy quét',
            Warehouse: "Kho",
        },
        column: {
            image: 'Ảnh',
            name: 'Tên',
            price: 'Giá',
            buying_price: 'Giá vốn',
            selling_price: 'Giá bán',
            sku: 'Mã SKU',
            stock: 'Tồn kho',
            quantity: 'Số lượng',
            latest_stock: 'Còn lại',
            product_deleted: 'Sản phẩm đã bị xóa',
            info_not_found: 'Thông tin không có sẵn',
            expired_date: 'Hạn sử dụng',
            invoice: 'Hóa đơn'
        },
        no_product: 'Không có sản phẩm nào',
        no_product_subtitle: 'Thêm sản phẩm đầu tiên của bạn để bắt đầu theo dõi kho hàng, giá cả và doanh số.',
        create_first_product: 'Tạo sản phẩm đầu tiên của bạn',
        add_product: {
            sku: 'Mã sản phẩm',
            sku_placeholder: 'Mã sản phẩm. Ví dụ: 12345',
            name: 'Tên sản phẩm',
            name_placeholder: 'Nhập tên sản phẩm',
            initial_stock: 'Tồn kho ban đầu',
            initial_stock_placeholder: 'Nhập tồn kho ban đầu',
            buying_price: 'Giá vốn',
            buying_price_placeholder: 'Nhập giá vốn',
            selling_price: 'Giá bán',
            selling_price_placeholder: 'Nhập giá bán',
            category: 'Danh mục',
            category_placeholder: 'Chọn danh mục',
            add_selling_price: 'Thêm giá bán sỉ',
            expired_date: 'Hạn sử dụng',
            expired_date_placeholder: 'Chọn ngày',
            description: 'Mô tả',
            description_placeholder: 'Nhập mô tả',
            custom_label: 'Thuộc tính',
            custom_label_placeholder: 'Nhập tên thuộc tính',
            add_custom_label: 'Thêm thuộc tính khác',
            Warehouse: "Kho",
        },
        customerLabel: {},
        choose_selling_price: 'Chọn giá bán',
        selling_price: 'Giá bán',
        total_product: 'Tổng sản phẩm',
        total_quantity: 'Tổng tồn kho',
        total_buying_price: 'Tổng giá vốn',
        total_selling_price: 'Tổng giá bán',
        message: {
            required_name: 'Tên sản phẩm là bắt buộc',
            required_sku: 'Mã SKU là bắt buộc',
            required_category: 'Danh mục là bắt buộc',
            required_quantity: 'Tồn kho ban đầu là bắt buộc',
            invalid_input_qty: 'Số lượng tồn kho không hợp lệ',
            required_buying_price: 'Giá vốn là bắt buộc',
            required_selling_price: 'Giá bán là bắt buộc',
            required_selling_price_name: 'Tên giá bán là bắt buộc',
            required_selling_price_price: 'Giá bán là bắt buộc'
        },
        viewMore: 'Xem thêm',
        WarehouseDetails: 'Chi tiết kho hàng',
        WarehouseName: 'Tên kho hàng',
        AddWarehouse: 'Thêm kho hàng',
        WarehouseQty: 'Số lượng kho',
        Warehouse: 'Kho hàng',
        Warehouses: 'Kho hàng',
        Variants: 'Biến thể',
        VariantName: 'Tên biến thể',
        productVariant: 'Biến thể sản phẩm',
        AddVariant: 'Thêm biến thể',
        TranferItem: 'Chuyển hàng',
        AddUnit: 'Đơn vị mới',
        InitialStkWarehouse: 'Cần tồn kho ban đầu để thêm biến thể',
        InitialStockinwarehouse: 'Tồn kho ban đầu trong kho',
        TotalQuantity: 'Tổng số lượng:',
        AddNote: 'Thêm ghi chú (giá vốn)',
        AddNotetitle: 'Thêm ghi chú',
        VariantSuccessMessage: 'Biến thể sản phẩm đã cập nhật thành công',
        Next: 'Tiếp theo',
        Submit: 'Xác nhận',
        INACTIVE: 'KHÔNG HOẠT ĐỘNG',
        errorone: 'Rất tiếc! Số lượng yêu cầu cho',
        errortwo: 'không khớp với số lượng phân bổ tại các kho. Vui lòng điều chỉnh số lượng hoặc nhập kho bổ sung.',
        SelectWarehouse: 'Chọn kho hàng',
        SelectVariant: 'Chọn biến thể',
        Discount: 'Chiết khấu',
        DiscountDetails: 'Chi tiết chiết khấu',
        FinalPrice: 'Giá cuối cùng',
        DiscountType: 'Loại chiết khấu',
        DiscountPer: 'Chiết khấu %',
        DiscountValue: 'Giá trị chiết khấu',
        Discountonprice: 'Chiết khấu trên giá',
        Discountondiscount: 'Chiết khấu trên chiết khấu',
        AdditionalDiscount: 'Chiết khấu bổ sung',
        SellingPrice: 'Giá bán:',
        Save: 'Lưu',
        OnOriginalPrice: 'Trên giá gốc',
        OnDiscountedPrice: 'Trên giá đã chiết khấu',
        columnSelector: {
            title: 'Hiển thị cột',
            columnsButton: 'Cột',
            costPrice: 'Giá vốn',
            sellingPrice: 'Giá bán',
            sku: 'SKU',
            warehouse: 'Kho hàng',
            categories: 'Danh mục',
            safetyStock: 'Kho an toàn',
            attributes: 'Thuộc tính',
            notes: 'Ghi chú',
            description: 'Mô tả',
            more: 'thêm',
            attribute: 'Thuộc tính',
            attributesTitle: 'Thuộc tính',
            categoriesTitle: 'Danh mục',
            skuAliases: 'Bí danh SKU'
        }
    },
    note: {
        title: 'Ghi chú',
        add: 'Thêm ghi chú',
        no_note: 'Không có ghi chú nào'
    },
    settings: {
        category: 'Danh mục',
        language: 'Ngôn ngữ',
        switch_business: 'Chuyển đổi doanh nghiệp',
        currencySelect: 'Tiền tệ',
        languageChangeSuccess: 'Cập nhật tiền tệ thành công',
        languageChangeErrorMessage: 'Có lỗi khi cập nhật tiền tệ',
        currencyAdded: "Đã thêm tiền tệ thành công",
        currencyDelete: "Đã xóa tiền tệ thành công",
        Selectyourpreferredlanguage: "Chọn ngôn ngữ bạn thích",
    },
    selectProductStock: 'Chọn sản phẩm',
    category: {
        category_list: {
            title: 'Danh mục sản phẩm'
        },
        add_category: {
            button: 'Danh mục mới',
            title: 'Thêm danh mục mới'
        },
        edit_category: {
            title: 'Sửa danh mục'
        },
        name: 'Tên danh mục',
        name_placeholder: 'Nhập tên danh mục',
        no_category: 'Không có danh mục nào'
    },
    staff: {
        add: 'Thêm nhân viên',
        edit: 'Sửa nhân viên',
        access: {
            stock: 'Kho hàng',
            add_product: 'Thêm sản phẩm mới',
            edit_product: 'Sửa sản phẩm',
            delete_product: 'Xóa sản phẩm',
            view_capital_price: 'Xem giá vốn',
            add_category: 'Thêm danh mục mới',
            edit_category: 'Sửa danh mục',
            delete_category: 'Xóa danh mục',
            add_supplier: 'Thêm nhà cung cấp mới',
            edit_supplier: 'Sửa nhà cung cấp',
            delete_supplier: 'Xóa nhà cung cấp',
            add_customer: 'Thêm khách hàng mới',
            edit_customer: 'Sửa khách hàng',
            delete_customer: 'Xóa khách hàng',
            add_staff: 'Thêm nhân viên',
            edit_staff: 'Sửa nhân viên',
            delete_staff: 'Xóa nhân viên',
            change_business_profile: 'Thay đổi hồ sơ doanh nghiệp',
            access_by_product_category: 'Quyền theo danh mục sản phẩm',
            no_category_message: 'Bạn chưa có danh mục nào. Vui lòng thêm danh sách danh mục.',
            expenses: 'Chi phí',
            view_expenses: 'Xem chi phí',
            add_expenses: 'Thêm chi phí',
            edit_expenses: 'Sửa chi phí',
            delete_expenses: 'Xóa chi phí',
            warehouse: 'Kho hàng',
            add_new_warehouse: 'Thêm kho hàng mới',
            edit_warehouse: 'Sửa kho hàng',
            delete_warehouse: 'Xóa kho hàng',
            transfer_warehouse: 'Chuyển kho',
            transfer_warehouse_approval: 'Phê duyệt chuyển kho',
            access_by_warehouse: 'Quyền theo kho hàng',
            no_warehouse_message: 'Bạn chưa có kho hàng nào. Vui lòng thêm danh sách kho hàng.',
            purchase_order: "Đơn mua hàng",
            purchase_order_creation: "Tạo đơn mua hàng",
            purchase_order_edit: "Chỉnh sửa đơn mua hàng",
            purchase_order_cancel: "Hủy đơn mua hàng",
            purchase_order_reopen: "Mở lại đơn mua hàng",
            purchase_order_receive: "Nhận đơn mua hàng",
            sales_order: "Đơn bán hàng",
            sales_order_creation: "Tạo đơn bán hàng",
            sales_order_edit: "Chỉnh sửa đơn bán hàng",
            sales_order_cancel: "Hủy đơn bán hàng",
            sales_order_reopen: "Mở lại đơn bán hàng",
            sales_order_receive: "Đơn bán hàng đã giao",
            purchase_order_approval: "Phê duyệt đơn mua hàng",
            sales_order_approval: "Phê duyệt đơn bán hàng",
            can_do_available_warehouse: "Kho có sẵn",
            add_batch: "Phê duyệt tạo lô"
            ,
            notification: 'Thông báo',
            staffNotification: 'Bật thông báo',
            assignee: "Người được giao",
        },
        no_staff: 'Không có nhân viên nào.'
    },
    code: {
        title: 'Nhân viên mới đã được thêm!',
        subtitle: 'Chia sẻ mã mời bên dưới để tham gia:',
        valid: 'Mã chỉ có hiệu lực trong 48 giờ',
        share: 'Chia sẻ qua WhatsApp',
        copied: 'Đã sao chép!',
        invalid: 'Mã không hợp lệ!'
    },
    history: {
        no_history: 'Không có lịch sử.',
        detail: {
            remove: 'Xóa lịch sử',
            confirm: 'Tính năng này sẽ ảnh hưởng đến tồn kho hiện tại, lịch sử và báo cáo.'
        },
        no_history_selected: "Chưa chọn lịch sử nào",
        select_history_hint: "Nhấp vào một lịch sử trong danh sách để xem chi tiết",
        select_from_left: "Chọn từ bảng bên trái",
    },
    supplier: {
        add: {
            title: 'Thêm nhà cung cấp'
        },
        edit: {
            title: 'Sửa nhà cung cấp'
        },
        new: 'Nhà cung cấp mới',
        no_supplier: 'Không có nhà cung cấp nào.',
        bank: {
            title: 'Thông tin ngân hàng'
        },
        note: 'Ghi chú',
        form: {
            name: {
                label: 'Tên nhà cung cấp',
                placeholder: 'Nhập tên nhà cung cấp',
                placheolder_not_mandatory: 'Nhập tên',
                error: {
                    required: 'Tên không được để trống'
                }
            },
            contact: {
                label: 'Số liên hệ',
                placeholder: '91934554432',
                error: {
                    required: 'Số liên hệ không được để trống',
                    invalid: 'Số không hợp lệ. Phải bao gồm mã quốc gia'
                }
            },
            bank_name: {
                label: 'Tên ngân hàng',
                placeholder: 'Nhập tên ngân hàng'
            },
            bank_account_name: {
                label: 'Tên chủ tài khoản',
                placeholder: 'Nhập tên chủ tài khoản'
            },
            bank_account_number: {
                label: 'Số tài khoản',
                placeholder: 'Nhập số tài khoản'
            },
            note: {
                label: 'Ghi chú',
                placeholder: 'Thêm ghi chú'
            },
            openingBalance: {
                addBtn: 'Thêm số dư đầu kỳ',
                label: 'Số dư đầu kỳ',
                placeholder: 'Nhập số dư đầu kỳ',
                error: {
                    negative: 'Số dư đầu kỳ không thể là số âm'
                }
            }
        },
        choose: 'Chọn nhà cung cấp'
    },
    customer: {
        add: {
            title: 'Thêm khách hàng'
        },
        edit: {
            title: 'Sửa khách hàng'
        },
        new: 'Khách hàng mới',
        no_customer: 'Không có khách hàng nào.',
        note: 'Ghi chú',
        form: {
            name: {
                label: 'Tên khách hàng',
                placeholder: 'Nhập tên khách hàng',
                placheolder_not_mandatory: 'Nhập tên',
                error: {
                    required: 'Tên không được để trống'
                }
            },
            contact: {
                label: 'Số liên hệ',
                placeholder: '91934554432',
                error: {
                    required: 'Số liên hệ không được để trống',
                    invalid: 'Số không hợp lệ. Phải bao gồm mã quốc gia'
                }
            },
            address: {
                label: 'Địa chỉ',
                placeholder: 'Nhập địa chỉ'
            },
            note: {
                label: 'Ghi chú',
                placeholder: 'Thêm ghi chú'
            },
            openingBalance: {
                addBtn: 'Thêm số dư đầu kỳ',
                label: 'Số dư đầu kỳ',
                placeholder: 'Nhập số dư đầu kỳ',
                error: {
                    negative: 'Số dư đầu kỳ không thể là số âm'
                }
            }
        },
        choose: "Chọn khách hàng",
        report: {
            view: 'Xem báo cáo khách hàng',
            title: 'Báo cáo khách hàng',
            no_report: 'Không có báo cáo cho khách hàng trong ngày đã chọn.',
            column: {
                name: 'Tên',
                total_transaction: 'Tổng giao dịch',
                total_amount: 'Tổng doanh thu',
                total_profit: 'Tổng lợi nhuận'
            }
        }
    },
    confirm_delete: 'Bạn có chắc chắn muốn xóa dữ liệu này không?',
    report: {
        title: 'Báo cáo'
    },
    accounting: {
        download_pdf_report: 'Tải xuống PDF',
        title: 'Kế toán',
        view_report: 'Xem báo cáo tài chính',
        dashboard_title: 'Báo cáo tài chính',
        stats: 'Thống kê',
        accounting_report: 'Báo cáo kế toán',
        filter: {
            date: {
                placeholder: 'Chọn ngày',
                submit: 'Áp dụng',
                cancel: 'Đặt lại bộ lọc'
            },
            timeframe: {
                day: 'Hàng ngày',
                week: 'Hàng tuần',
                month: 'Hàng tháng',
                year: 'Hàng năm'
            }
        },
        total_sales: 'Tổng doanh thu',
        total_purchases: 'Tổng mua hàng',
        total_profit: 'Tổng lợi nhuận',
        total_expenses: 'Tổng chi phí',
        assets_value: 'Giá trị tài sản hiện tại',
        total_current_cogs_value: 'Tổng giá trị COGS hiện tại',
        current_asset_selling_price: 'Giá bán tài sản hiện tại',
        total_selling_price: 'Tổng giá bán',
        table: {
            date: 'Ngày',
            sales: 'Doanh thu',
            purchases: 'Mua hàng',
            profit: 'Lợi nhuận',
            expenses: 'Chi phí'
        },
        no_data: 'Không có dữ liệu.'
    },
    stock_report: {
        title: 'Báo cáo tồn kho',
        view: 'Xem báo cáo tồn kho',
        no_report: 'Không có hồ sơ tồn kho cho ngày hoặc nhân viên đã chọn.',
        allStaffPlaceHolder: 'Tất cả nhân viên',
        column: {
            total_product: 'Số loại sản phẩm hiện tại',
            total_product_quantity: 'Tổng số lượng sản phẩm hiện tại'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Tính năng VIP',
            description:
                'Thời gian dùng thử tính năng này đã hết. Hãy ủng hộ sự phát triển của ứng dụng địa phương này bằng cách đăng ký gói trả phí.',
            button: 'Xem các gói đăng ký'
        }
    },
    payment: {
        order: {
            title: 'Thanh toán'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Kích thước ảnh không được vượt quá 5MB!',
        failedMessage: 'Tải ảnh sản phẩm thất bại, vui lòng thử lại!',
        successUpload: 'Ảnh đã được tải lên thành công!',
        failedUIError: 'Xóa ảnh thất bại, vui lòng thử lại!',
        SuccessErrorImage: 'Ảnh đã được xóa thành công!'
    },
    productColumns: {
        SKULabel: 'Mã SKU',
        nameLabel: 'Tên sản phẩm',
        categoryLabel: 'Danh mục',
        BuyingPriceLabel: 'Giá vốn',
        SellingLabel: 'Giá bán',
        StockLabel: 'Tồn kho'
    },
    historyColumns: {
        Transactionlabel: 'Loại giao dịch',
        Locallabel: 'Thời gian địa phương',
        Createdlabel: 'Tạo bởi',
        Vendorlabel: 'Tên nhà cung cấp',
        Buyerlabel: 'Tên người mua',
        SKUlabel: 'Mã SKU',
        Invoicelabel: 'Hóa đơn',
        Productlabel: 'Tên sản phẩm',
        Categorylabel: 'Danh mục',
        Buyinglabel: 'Giá vốn',
        Sellinglabel: 'Giá bán',
        Initiallabel: 'Tồn kho ban đầu',
        Finallabel: 'Tồn kho cuối',
        Stocklabel: 'Thay đổi tồn kho'
    },
    stockReportColumns: {
        skuLabel: 'Mã SKU',
        productNameLabel: 'Tên sản phẩm',
        categoryLabel: 'Danh mục',
        buyingPriceLabel: 'Giá vốn',
        sellingPriceLabel: 'Giá bán',
        stockInLabel: 'Nhập kho',
        stockOutLabel: 'Xuất kho',
        remainingStockLabel: 'Tồn kho còn lại',
        openStockLabel: 'Tồn kho đầu kỳ',
        weightedAverageCost: 'Giá vốn bình quân gia quyền',
        weightedAverageCostLabel: 'Giá vốn bình quân gia quyền',
        weightedAverageValueLabel: 'Giá trị bình quân gia quyền'
    },
    accountingReportColumns: {
        dateRange: 'Khoảng ngày',
        reportingPeriod: 'Kỳ báo cáo',
        reportGenerate: 'Tạo báo cáo',
        warehouse: 'Kho',
        labelDate: 'Ngày',
        labelSales: 'Doanh thu',
        labelPurchases: 'Mua hàng',
        labelProfit: 'Lợi nhuận',
        labelExpenses: 'Chi phí',
        reportOptions: 'Cột báo cáo',
        summaryCards: 'Thẻ tóm tắt',
        grandTotal: 'Tổng cộng',
        continued: 'tiếp',
        subtotal: 'Tổng phụ',
        page: 'Trang'
    },
    customerReportColumns: {
        labelName: 'Tên',
        labelTotalTransaction: 'Tổng giao dịch',
        labelTotalSales: 'Tổng doanh thu',
        labelTotalProfit: 'Tổng lợi nhuận'
    },
    scannerDialog: {
        finished: 'Hoàn tất',
        reduce: 'Giảm',
        successfull: 'Thành công',
        searching: 'Đang tìm kiếm...',
        title: 'Máy quét đang hoạt động. Hãy hướng vào mã vạch!'
    },
    historyFilter: {
        SelectBuyer: 'Chọn người mua',
        SelectVendor: 'Chọn nhà cung cấp'
    },
    productStockFilter: {
        StockLowtoHigh: 'Tồn kho từ thấp đến cao',
        StockHightoLow: 'Tồn kho từ cao đến thấp',
        AlphabetAZ: 'Chữ cái A-Z',
        AlphabetZA: 'Chữ cái Z-A'
    },
    minimizeTitle: 'Máy quét đang hoạt động',
    security_guarantee: {
        title: 'Bảo mật dữ liệu được đảm bảo'
    },
    invoice: {
        invoicePlaceholder: 'Số hóa đơn',
        invoiceTitle: 'Hóa đơn',
        manageInvoiceAddress: 'Quản lý địa chỉ hóa đơn',
        selectOrManageAddresses: 'Chọn, chỉnh sửa hoặc tạo địa chỉ hóa đơn tùy chỉnh',
        useBusinessProfileAddress: 'Sử dụng địa chỉ hồ sơ doanh nghiệp',
        noCustomAddressesFound: 'Chưa thêm địa chỉ tùy chỉnh',
        createCustomAddressDesc: 'Thêm địa chỉ thanh toán hoặc chi nhánh tùy chỉnh để in trên hóa đơn của bạn thay vì dữ liệu hồ sơ doanh nghiệp mặc định.',
        defaultFromBusinessProfile: 'Mặc định từ hồ sơ doanh nghiệp',
        editInvoiceAddress: 'Chỉnh sửa địa chỉ hóa đơn',
        createNewInvoiceAddress: 'Tạo địa chỉ hóa đơn mới',
        logoHeaderImage: 'Logo / Hình ảnh tiêu đề',
        deleteInvoiceAddress: 'Xóa địa chỉ hóa đơn?',
        deleteAddressConfirmText: 'Bạn có chắc chắn muốn xóa địa chỉ hóa đơn này không? Hành động này không thể hoàn tác.'
    },
    ManageInvoiceAddress: 'Quản lý địa chỉ hóa đơn',
    SelectOrManageAddresses: 'Chọn, chỉnh sửa hoặc tạo địa chỉ hóa đơn tùy chỉnh',
    UseBusinessProfileAddress: 'Sử dụng địa chỉ hồ sơ doanh nghiệp',
    CreateNewAddress: 'Tạo địa chỉ mới',
    UpdatingList: 'Đang cập nhật danh sách...',
    NoCustomAddressesFound: 'Chưa thêm địa chỉ tùy chỉnh',
    CreateCustomAddressDesc: 'Thêm địa chỉ thanh toán hoặc chi nhánh tùy chỉnh để in trên hóa đơn của bạn thay vì dữ liệu hồ sơ doanh nghiệp mặc định.',
    DefaultFromBusinessProfile: 'Mặc định từ hồ sơ doanh nghiệp',
    EditInvoiceAddress: 'Chỉnh sửa địa chỉ hóa đơn',
    CreateNewInvoiceAddress: 'Tạo địa chỉ hóa đơn mới',
    LogoHeaderImage: 'Logo / Hình ảnh tiêu đề',
    UploadingImage: 'Đang tải lên hình ảnh...',
    UploadImage: 'Tải lên hình ảnh',
    BusinessName: 'Tên doanh nghiệp',
    AddressDetails: 'Chi tiết địa chỉ',
    PhoneNumber: 'Số điện thoại',
    EmailAddress: 'Địa chỉ email',
    DeleteInvoiceAddress: 'Xóa địa chỉ hóa đơn?',
    DeleteAddressConfirmText: 'Bạn có chắc chắn muốn xóa địa chỉ hóa đơn này không? Hành động này không thể hoàn tác.',

    stocklowreport: {
        no_stocklowreport_one: 'Không có mặt hàng nào được thiết lập Tồn kho an toàn.',
        no_stocklowreport_two: 'Vui lòng thêm số lượng Tồn kho an toàn.',
        currentStock: 'Tồn kho hiện tại',
        safetyStock: 'Tồn kho an toàn',
        pricing: 'Định giá',
        costPrice: 'Giá vốn',
        sellingPrice: 'Giá bán',
        productInfo: 'Thông tin sản phẩm',
        category: 'Danh mục',
        description: 'Mô tả',
        no_description: 'Chưa có mô tả',
        variants: 'Biến thể',
        unitsOnHand: 'đơn vị hiện có',
        minimumThreshold: 'ngưỡng tối thiểu',
        adjust: 'Điều chỉnh',
        all: 'Tất cả',
        lowStock: 'Tồn kho thấp',
        variantsDetails: 'Chi tiết biến thể',
        qty: 'SL',
        addSafetyStock: 'Thêm tồn kho an toàn',
        searchByNameSku: 'Tìm theo tên/SKU',
        safetyStockShort: 'A',
        warehouseSafetyStock: 'Tồn kho an toàn của kho'
    },
    low_alert_stock: 'Nhập số lượng tồn kho an toàn',
    lowStockAlertNotify: "Bạn sẽ nhận được thông báo khi tồn kho giảm xuống dưới mức đã thiết lập",
    applyButtonStockAlert: 'Áp dụng',
    cancelButtonStockAlert: 'Hủy',
    searchProductLabel: 'Tìm kiếm sản phẩm...',
    successfullyAddedSafetyStock: 'Cập nhật Tồn kho an toàn thành công',
    safety_Stock: 'Tồn kho an toàn',
    safety_stock_placeholder: 'Nhập số lượng tồn kho an toàn',
    lowStockDetailsInfo: {
        ProductCode: 'Mã sản phẩm',
        SafetyStock: 'Tồn kho an toàn',
        Stock: 'Tồn kho',
        CostPrice: 'Giá vốn',
        SellingPrice: 'Giá bán',
        Category: 'Danh mục',
        Description: 'Mô tả',
        ExpirationDate: 'Hạn sử dụng'
    },
    CustomLang: {
        Attribute: 'Thuộc tính',
        AddAttribute: 'Thêm thuộc tính',
        EditAttribute: 'Sửa thuộc tính',
        CustomLabePlaceholder: 'Nhập tên thuộc tính',
        CustomLabePlaceholderSelect: 'Chọn loại',
        AddMoreAttribute: 'Thêm thuộc tính khác',
        ItemAttribute: 'Thuộc tính sản phẩm',
        TableName: 'Tên',
        TableType: 'Loại',
        TableAction: 'Hành động',
        TableDelete: 'Xóa',
        TableEdit: 'Sửa',
        deleteMessage: 'Xóa thuộc tính thành công',
        editSuccessMessage: 'Cập nhật thuộc tính thành công',
        AddSuccessMessage: 'Thêm thuộc tính thành công',
        AddAtt: 'Thêm',
        EditAtt: 'Sửa',
        SubmitAtt: 'Đang gửi...'
    },
    Expenses: {
        ExpensesTitle: 'Chi phí',
        AddExpenses: 'Thêm chi phí',
        ExpenseCategory: 'Danh mục chi phí',
        NoExpenseCategory: 'Không có danh mục chi phí',
        AddExpenseCategory: 'Thêm danh mục chi phí',
        SelectExpenseCategory: 'Chọn danh mục chi phí',
        NoExpenses: 'Không có chi phí nào',
        ExpensesSuccess: 'Tạo chi phí thành công',
        ExpensesSuccessEdit: 'Cập nhật chi phí thành công',
        ExpensesCategoryName: 'Tên danh mục chi phí',
        ExpensesSuccessDelete: 'Xóa chi phí thành công',
        AddNEC: 'Thêm danh mục chi phí mới',
        NC: 'Danh mục chi phí mới',
        EditNEC: 'Sửa danh mục chi phí'
    },
    Manufacturing: {
        ProducedProduct: "Sản phẩm sản xuất",
        QuantityManufactured: "Số lượng sản xuất",
        UnitCost: "Chi phí đơn vị",
        RawMaterialsTotal: "Tổng nguyên liệu thô",
        TotalManufacturingCost: "Tổng chi phí sản xuất",
        NoRawMaterialsConsumed: "Không có nguyên liệu tiêu thụ.",
        CostBreakdown: "Bản phân tích chi phí",
        GeneratedBatch: "Lô hàng được tạo",
        StoredBinLocation: "Vị trí lưu kho",
        NoManufacturingTransactionsFound: "Không tìm thấy giao dịch sản xuất",
        AddManufacture: 'Thêm chi tiết sản xuất',
        Manufacturing: 'Sản xuất',
        RawMaterials: 'Nguyên liệu thô',
        AdditonCosts: 'Chi phí bổ sung',
        RawMaterial: 'Nguyên liệu thô',
        AdditonCost: 'Chi phí bổ sung',
        TotalCost: 'Tổng chi phí',
        AddRawMaterial: 'Thêm nguyên liệu thô cho',
        AddAdditonCost: 'Thêm chi phí bổ sung cho',
        AddMore: 'Thêm nữa',
        Add: 'Thêm',
        Update: 'Cập nhật',
        Updating: 'Đang gửi...',
        ProductRequired: 'Sản phẩm là bắt buộc',
        QuantityRequired: 'Số lượng là bắt buộc',
        ChargeRequired: 'Chi phí là bắt buộc',
        EstimatedCostRequired: 'Chi phí dự kiến là bắt buộc',
        PurchasePriceRequired: 'Giá mua là bắt buộc',
        SelectCharge: 'Chọn loại chi phí',
        EstimatedCost: 'Chi phí dự kiến',
        SelectProduct: 'Chọn sản phẩm',
        Quantity: 'Số lượng',
        ManufactureDetails: 'Chi tiết sản xuất',
        BuyingPrice: 'Giá vốn',
        LabourCharge: 'Chi phí nhân công',
        ElectricityCost: 'Chi phí điện',
        PackagingCharge: 'Chi phí đóng gói',
        LogisticCost: 'Chi phí vận chuyển',
        OtherCharges: 'Chi phí khác',
        Save: 'Lưu chi tiết',
        PurchasePrice: 'Giá mua',
        Date: 'Ngày',
        For: 'Cho',
        PurchaseRate: 'Giá mua (đơn giá)',
        Scrolltoloadmore: 'Kéo xuống để tải thêm...',
        Noproductsfound: 'Không tìm thấy sản phẩm nào',
        ManufacturingQuantity: 'Số lượng sản xuất',
        ManufactureAddedSuccess: 'Cập nhật chi tiết sản xuất thành công'
    },
    Warehouses: {
        transferOrder: 'Chuyển hàng',
        AddTransferOrder: 'Thêm lệnh chuyển hàng',
        NewWarehouse: 'Kho hàng mới',
        newHead: 'Bắt đầu quản lý nhiều kho hàng!',
        headTwo: 'Theo dõi và quản lý tồn kho liền mạch trên nhiều kho hàng',
        EnableWarehouse: 'KÍCH HOẠT KHO HÀNG',
        EnableWarehouse2: 'Kích hoạt kho hàng',
        OrganizationPrimary: 'Kho chính của tổ chức',
        Edit: 'Sửa',
        AreEnableWarehouse: 'Bạn có chắc chắn muốn kích hoạt kho hàng không?',
        Confirm: 'Xác nhận',
        Cancel: 'Hủy',
        WarehouseCreatedSuccessfully: 'Tạo kho hàng thành công',
        MarkAsOP: 'Đánh dấu làm kho chính của tổ chức',
        MarkAsInAct: 'Đánh dấu không hoạt động',
        MarkAsAct: 'Đánh dấu hoạt động',
        MarkedAsInactive: 'Kho hàng đã được đánh dấu không hoạt động thành công',
        MarkedAsActive: 'Kho hàng đã được đánh dấu hoạt động thành công',
        MarkedAsOP: 'Kho hàng đã được đánh dấu hoạt động thành công',
        WareDeletedSuccess: 'Xóa kho hàng thành công',
        SuccessfullyUpdatedWarehouse: 'Cập nhật kho hàng thành công',
        SuccessfullyCreatedWarehouse: 'Tạo kho hàng thành công',
        EditWarehouse: 'Sửa kho hàng',
        AddWarehouse: 'Thêm kho hàng',
        WarehouseNameIsRequired: 'Tên kho hàng là bắt buộc',
        EnterWarehouseName: 'Nhập tên kho hàng',
        EnterEmail: 'Nhập email',
        EnterPhoneNumber: 'Nhập số điện thoại',
        Location: 'Vị trí...',
        name: 'Tên kho hàng',
        email: 'Email',
        phoneNumber: 'Số điện thoại',
        location: 'Vị trí',
        ViewProducts: 'Xem sản phẩm',
        PageTitle: 'Kho hàng',
        noWarehouse: "Không có kho nào khớp với tìm kiếm của bạn"
    },
    Assets: {
        headerTitle: 'Tài sản',
        addAssetMessage: "Thêm tài sản tại đây. Để phân bổ tài sản cho nhân viên, hãy vào hồ sơ của nhân viên đó.",
        addAsset: 'Thêm tài sản',
        editAsset: 'Sửa tài sản',
        assetCode: 'Mã tài sản',
        assetName: 'Tên tài sản',
        assetCategory: 'Danh mục tài sản',
        assetType: 'Loại tài sản',
        serialNumber: 'Số serial',
        location: 'Vị trí',
        condition: 'Tình trạng',
        selectCondition: 'Chọn tình trạng',
        fair: 'Trung bình',
        good: 'Tốt',
        excellent: 'Xuất sắc',
        poor: 'Kém',
        notes: 'Ghi chú',
        submit: 'Gửi',
        submitting: 'Đang gửi',
        noCategory: 'Không có danh mục',
        selectCategory: 'Chọn danh mục',
        addAssetCat: 'Thêm danh mục tài sản',
        addAssetCatName: 'Tên danh mục tài sản',
        edit: 'Sửa',
        status: 'Trạng thái',
        createdAt: 'Ngày tạo',
        viewAsset: 'Xem tài sản',
        assignAsset: 'Phân bổ tài sản',
        conditionRet: 'Tình trạng (khi trả)',
        searchSelectAssets: 'Tìm kiếm/Chọn tài sản',
        assetAssigned: 'Phân bổ tài sản thành công',
        assetReturned: 'Trả tài sản thành công',
        selectAnAsset: 'Vui lòng chọn một tài sản',
        action: 'Hành động',
        noAssetAssigned: 'Không có tài sản nào được phân bổ',
        reAssigned: 'Phân bổ lại',
        assignedAssetsList: 'Danh sách tài sản đã phân bổ',
        viewHistory: 'Xem lịch sử',
        history: 'Lịch sử tài sản',
        loadingHistory: 'Đang tải lịch sử...',
        loadingMore: 'Đang tải thêm...',
        dateTime: 'Ngày & Giờ',
        staff: 'Nhân viên',
        AssignedBy: 'Phân bổ bởi',
        assign: 'PHÂN BỔ',
        return: 'TRẢ',
        unknown: 'KHÔNG XÁC ĐỊNH',
        noHistory: 'Không có lịch sử cho tài sản này.',
        enterReturnNote: 'Nhập ghi chú khi trả',
        returnNote: 'Ghi chú trả',
        enterAssignNote: 'Nhập ghi chú khi phân bổ',
        assignNote: 'Ghi chú phân bổ',
        AddNAC: 'Thêm danh mục tài sản mới',
        EditNAC: 'Sửa danh mục tài sản',
        others: 'Khác'
    },
    LedgerTransaction: {
        ledgerDetails: 'Chi tiết sổ cái',
        productName: 'Tên sản phẩm',
        totalQty: 'Tổng số lượng',
        date: 'Ngày',
        receivedAmt: 'Số tiền nhận',
        paid: 'Đã thanh toán',
        discount: 'Chiết khấu',
        balance: 'Số dư',
        more: 'thêm',
        total: 'Tổng cộng',
        ledgerupdatedsuccessfully: 'Cập nhật sổ cái thành công',
        ledgeraddedsuccessfully: 'Thêm sổ cái thành công',
        viewLedger: 'Xem sổ cái',
        edit: 'Sửa',
        create: 'Tạo',
        Recieved: 'Nhận [nhập kho]',
        payMode: 'Hình thức thanh toán',
        Refno: 'Số tham chiếu'
    },
    ExtraField: {
        attachment: 'Tệp đính kèm',
        acceptOnlyImg: 'Chỉ chấp nhận hình ảnh.',
        addAttribute: 'Thêm thuộc tính',
        acceptImgAndDoc: 'Chấp nhận hình ảnh và tài liệu.'
    },
    phoneInvoiceDownload: {
        Variant: 'Biến thể',
        Warehouse: 'Kho hàng',
        Bin: 'Thùng',
        Batch: 'Lô',
        Attributes: 'Thuộc tính'
    },
    ImportExcel: {
        ImportStockfromExcel: "Nhập tồn kho từ Excel",
        DragDrop: "Kéo & thả file Excel đã điền vào đây, hoặc nhấn để duyệt",
        DT: "Tải mẫu",
        GB: "Quay lại",
        Downloading: "Đang tải...",
        ChangeFile: "Thay đổi file",
        ReadingExcelfile: "Đang đọc file Excel...",
        Processing: "Đang xử lý...",
        submitUpdateStock: "Gửi & Cập nhật tồn kho",
        downloadLatestTemplate: "Tải mẫu mới nhất",
        loginRequired: "Yêu cầu đăng nhập"
    },
    stockForm: {
        recordPaymentNow: "Ghi nhận thanh toán ngay",
        recordPaymentDescCustomer: "Nhập số tiền khách hàng đã thanh toán",
        recordPaymentDescSupplier: "Nhập số tiền nhà cung cấp đã thanh toán",
        managePayments: "Quản lý thanh toán",
        invoice: "Hóa đơn",
        challan: "Phiếu xuất kho",
        recordPayment: "Ghi nhận thanh toán",
        payableAmount: "Số tiền phải thanh toán",
        paidAmount: "Số tiền đã thanh toán",
        paymentMethod: "Phương thức thanh toán",
        paymentDate: "Ngày thanh toán",
        reference: "Tham chiếu",
        billId: "Số hóa đơn",
        importExcel: "Nhập từ Excel",
        noThanks: "Không, cảm ơn",
        checkHistory: "Kiểm tra lịch sử của bạn",
        wantViewHistory: "Bạn có muốn xem lịch sử không?",
        enterPayable: 'Nhập số tiền phải thanh toán',
        enterPaid: 'Nhập số tiền đã thanh toán',
        selectPayment: "Chọn phương thức thanh toán",
        attachment: "Tệp đính kèm",
        note: "Ghi chú"
    },
    HistoryEdit: {
        products: "Sản phẩm",
        add_product: "Thêm sản phẩm",
        paidAmountInvalidMessage: 'Số tiền đã thanh toán không được lớn hơn số tiền phải thanh toán',
        removingText: "Việc xóa sản phẩm này sẽ đảo ngược thay đổi tồn kho đã thực hiện trong giao dịch này.",
        remove: "Xóa",
    },
    ExcelProduct: {
        uploadFile: "Tải lên file",
        dragDrop: "Kéo và thả file Excel của bạn, hoặc nhấn để tải lên.",
        parsingFile: "Đang phân tích file",
        fileSelected: "File đã chọn",
        reviewImportedData: "Xem lại dữ liệu đã nhập bên dưới. Các cột được tự động khớp nếu có thể.",
        changeFile: "Thay đổi file",
        back: "Quay lại",
        invalidFileType: "Vui lòng tải lên file Excel hợp lệ (.xlsx hoặc .xls)",
        parseExcelError: "Lỗi phân tích Excel:",
        noData: "File Excel đã tải lên không có dữ liệu.",
        failedToRead: "Không thể đọc file Excel. Vui lòng thử lại.",
        Nodata: "KHÔNG_CÓ_DỮ_LIỆU",
        unableToRead: "Không thể đọc file.",
        buyingMustNumber: "Giá vốn phải là số",
        sellingMustNumber: "Giá bán phải là số",
        mustBeNumber: "phải là số",
        bulkUploadfailed: "Tải lên hàng loạt thất bại",
        importFromExcel: "Nhập từ Excel",
        generating: "Đang tạo...",
        downloadTemplate: "Tải mẫu",
        uploading: "Đang tải lên...",
        done: "Hoàn tất",
        requiredField: "{field} là bắt buộc",
        bulkUpload: "Tải lên hàng loạt",
        duplicateSku: "Đã tìm thấy SKU trùng lặp",
        uploadedSuccessfully: "Tất cả sản phẩm đã được tải lên thành công!",
        uploadCompleteIssues: "Tải lên hoàn tất với lỗi",
        uploaded_products: "Đã tải lên {count} sản phẩm.",
        failed_products: "{count} thất bại.",
        failed_items: "Mục thất bại:"
    },
    ProductForm: {
        barcodeQuantity: "Nhập số lượng mã vạch",
        baseUnit: "Đơn vị cơ bản (Chính)",
        addSecondaryUnit: "Thêm đơn vị phụ?",
        selectUnit: "Chọn đơn vị",
        subUnitDetails: "Chi tiết đơn vị phụ",
        subUnit: "Đơn vị phụ",
        selectSubUnit: "Chọn đơn vị phụ",
        conversionRate: "Tỷ lệ quy đổi",
        exampleLogic: "Ví dụ logic:",
        example: "Nếu bạn bán bút theo hộp, hãy đặt Đơn vị cơ bản là Hộp và thêm Đơn vị phụ là cái với tỷ lệ quy đổi 50. Nghĩa là 1 Hộp chứa 50 cái.",
        basePrice: "Giá cơ bản",
    },
    barcode: {
        settings: 'Cài đặt mã vạch',
        labelSize: 'Kích thước nhãn',
        customSize: 'Kích thước tùy chỉnh...',
        widthMm: 'Chiều rộng (mm)',
        heightMm: 'Chiều cao (mm)',
        showPrice: 'Hiển thị giá bán trên nhãn',
        noPrices: 'Không có giá bán nào được cấu hình cho sản phẩm này.',
        preview: 'Xem trước',
        generate: 'Tạo',
        label: 'nhãn',
        singlePage: 'Trang đơn',
        downloadOptions: 'Tùy chọn tải xuống',
        chooseLayout: 'Chọn bố cục cho mã vạch',
        allInSinglePage: 'Thêm tất cả mã vạch vào một trang duy nhất.',
        allInA4Grid: 'Tất cả trong trang đơn',
        allInA4GridSub: 'Sắp xếp tất cả mã vạch trong lưới A4',
        onePerPage: 'Một trên mỗi trang',
        onePerPageSub: 'Mỗi mã vạch trên trang nhãn riêng của nó'
    },

    Discount: {
        overallDiscount: "Chiết khấu tổng",
        final: 'Cuối cùng',
        balanceDue: "Số dư còn phải trả",
        tax: "Thuế",
    },
    TransferItem: {
        transferItem: 'Chuyển hàng',
        Date: 'Ngày',
        Reason: 'Lý do',
        enterReason: "Nhập lý do",
        Name: 'Tên',
        QuantityTransfered: 'Số lượng chuyển',
        SWarehouse: 'Kho nguồn',
        SelectSWarehouse: 'Chọn kho nguồn',
        DWarehouse: 'Kho đích',
        SelectDWarehouse: 'Chọn kho đích',
        CreatedBy: 'Tạo bởi',
        CreatedTime: 'Thời gian tạo',
        UpdatedTime: 'Thời gian cập nhật',
        NoOrderFound: 'Không tìm thấy lệnh nào',
        New: 'Mới',
        WarehouseItemTransfer: 'Chuyển hàng kho',
        TotalTransfers: "Tổng Chuyển Kho",
        EnterReason: 'Nhập lý do',
        ItemDetails: 'Chi tiết mặt hàng',
        CurrentAvailable: 'Hiện có sẵn',
        TransferQty: 'Số lượng chuyển',
        SStock: 'Tồn kho nguồn',
        DStock: 'Tồn kho đích',
        addDescription: "Thêm mô tả cho mặt hàng",
        selectVariant: "Chọn biến thể",
        addNewRow: "Thêm dòng mới",
        typeOrSelectItem: "Nhập để tìm kiếm",
        scrollToLoadMore: "Kéo xuống để tải thêm",
        noProductsFound: "Không tìm thấy sản phẩm nào",
        selectWarehouse: "Chọn kho hàng"
    },
    Sku: {
        searchSelectProduct: "Tìm kiếm/Chọn sản phẩm",
        searchSelectSku: "Tìm kiếm/Chọn SKU",
        noSkuFound: "Không tìm thấy SKU nào"
    },
    HistoryPage: {
        addFilter: "Thêm bộ lọc",
        filtersActive: "Tất cả bộ lọc đang hoạt động",
        noProducts: "Không có sản phẩm",
        download: "Tải xuống",
        recentlyUpdated: "Cập nhật gần đây",
    },
    StockPage: {
        challanNumber: "Số phiếu xuất kho",
        subTotal: "Tổng phụ",
        totalTaxes: "Tổng cộng & Thuế",
        taxInclusive: "Đã bao gồm thuế",
        discountedValue: "Giá trị chiết khấu",
        taxValue: "Giá trị thuế",
        totalAmount: "Tổng số tiền",
        close: "Đóng",
        addTax: "Thêm thuế",
        label: "Nhãn",
        enterLabel: "Nhập nhãn",
        taxRate: "Tỷ lệ thuế",
        enterTaxRate: "Nhập tỷ lệ thuế",
        selectTaxRate: "Chọn tỷ lệ thuế",
        addNewTax: "Thêm mức thuế mới",
        discountProducts: "Giá trị chiết khấu (Sản phẩm)",
        taxProducts: "Giá trị thuế (Sản phẩm)",
        clickAddPayment: "Nhấn để thêm thanh toán",
        paidGreaterPayable: "Số tiền đã thanh toán không được lớn hơn số tiền phải thanh toán",
        vendorCompulsory: 'Nhà cung cấp là bắt buộc để ghi nhận thanh toán',
        customerCompulsory: "Cần có khách hàng để ghi nhận thanh toán",
        updateInvoiceFormat: "Cập nhật định dạng hóa đơn",
        updateChallanFormat: "Cập nhật định dạng phiếu xuất kho",
        addPrefix: "Thêm tiền tố",
        prefix: "Tiền tố"
    },
    EditHistoryPage: {
        search_by_notes: "Tìm kiếm theo ghi chú",
        alertMessage: "Thay đổi này chỉ được ghi nhận trong lịch sử và không ảnh hưởng đến tồn kho sản phẩm hiện tại.",
        paymentDetails: "Chi tiết thanh toán",
        units: "Đơn vị",
        customLabels: "Nhãn tùy chỉnh",
        value: "Giá trị",
        Order_Info: "Thông tin đơn hàng",
        percentage: "Phần trăm",
        Stock_updates_on_submit: "Cập nhật tồn kho khi gửi",
        Summary: "Tóm tắt"
    },
    historyCard: {
        paid: "ĐÃ THANH TOÁN",
        partiallyPaid: "THANH TOÁN MỘT PHẦN",
        billDate: "Ngày hóa đơn",
        productDetails: "Chi tiết sản phẩm",
        paymentsHistory: "Lịch sử thanh toán",
        updatePayment: "Cập nhật thanh toán",
        discounts: "Chiết khấu",
        inclusive: "(bao gồm)",
        discountOverall: "Giá trị chiết khấu (Tổng)",
        dueAmount: "Số tiền còn phải trả",
        enterPaid: "Nhập số tiền đã thanh toán",
        enterReference: "Nhập tham chiếu",
        enterNote: "Nhập ghi chú",
        enterInvoice: "Nhập hóa đơn",
        enterChallan: "Nhập phiếu xuất kho",
        edit: "Đã chỉnh sửa"
    },
    printInvoice: {
        billTo: "Thanh toán cho",
        ref: "Số tham chiếu",
        mode: "Phương thức",
        date: "Ngày",
        amount: "Số tiền",
        totalPaid: "Tổng đã thanh toán",
        noImage: "Không có ảnh"
    },
    Contact: {
        supplier_required: "Nhà cung cấp là bắt buộc cho nhập kho",
        customer_required: "Khách hàng là bắt buộc cho xuất kho",
        key: "Khóa",
        editHistory: "Sửa lịch sử",
        loading: "Đang tải..."
    },
    AW: {
        availablewarehouse: "Kho hàng có sẵn",
        visibilityManagement: 'Quản lý khả năng hiển thị',
        availablewarehouses: "Các kho hàng có sẵn",
        Active: "Hoạt động",
        LWarehouse: "Đang tải kho hàng...",
        NWForthisProduct: "Không tìm thấy kho hàng nào cho sản phẩm này.",
        of: "của",
        WarehouseAvailabilty: "Tình trạng sẵn có kho hàng",
    },
    Currency: {
        searchCurrency: "Tìm kiếm tiền tệ...",
        addCurrency: "Thêm tiền tệ",
        addNewCurrency: "Thêm tiền tệ mới",
        editCurrency: "Sửa tiền tệ",
        currencySymbol: "Ký hiệu tiền tệ",
        currencyName: "Tên tiền tệ",
        enterCurrencySymbol: "Nhập ký hiệu tiền tệ",
        enterCurrencyName: "Nhập tên tiền tệ"
    },
    NewReportLang: {
        DM: "Biến Động Hàng Ngày",
        WR: "Báo Cáo Kho",
        PDM: "Biến Động Sản Phẩm Hàng Ngày",
        TBP: "Tổng Giá Mua",
        TPQ: "Tổng Số Lượng Sản Phẩm",
        TP: "Tổng Sản Phẩm",
        CS: "Tồn Kho Hiện Tại",
        IV: "Giá Trị Hàng Tồn Kho",
        DA: "Trung Bình Hàng Ngày",
        TSI: "Tổng Hàng Nhập",
        TSO: "Tổng Hàng Xuất",
        TOR: "Tỷ Lệ Vòng Quay",
        Tv: "Tổng Giá Trị",
        AST: "Theo Dõi SKU Hoạt Động",
        UT: "Đơn Vị Được Theo Dõi",
        SL: "Mức Tồn Kho",
        Value: "Giá Trị",
        IO: "NHẬP/XUẤT",
        T: "Vòng Quay",
        unitsD: "Đơn Vị/Ngày",
        Sort: "Sắp xếp",
        Sort_by: "Sắp xếp theo",
        Units_available: "Đơn vị có sẵn",
        Units_unavailable: "Đơn vị không có sẵn",
        Current_assets: "Tài sản lưu động",
        Search: "Tìm kiếm",
        available: "Có sẵn",
        assigned: "Đã phân công",
        AYSWD: "Bạn có chắc chắn muốn xóa không?",
        PTS: "Kho đã chuyển thành công",
        AUS: "Tài sản đã cập nhật thành công",
        ACS: "Tài sản đã tạo thành công",
        VSP: "Xem giá bán",
        HUS: "Lịch sử đã cập nhật thành công",
    },
    ReplacementReturn: {
        selectProduct: "Vui lòng chọn sản phẩm",
        selectReplacementProduct: "Chọn ít nhất một sản phẩm thay thế",
        validQuantity: "Vui lòng nhập số lượng trả hợp lệ",
        replacedSuccessfully: "Sản phẩm đã được thay thế thành công",
        returnSuccessfully: "Sản phẩm đã được trả thành công",
        failedProcess: "Xử lý thất bại. Vui lòng thử lại.",
        return: "Trả hàng",
        replace: "Thay thế",
        typeSelectProduct: "Nhập hoặc chọn sản phẩm...",
        returnQuantity: "Số lượng trả",
        enterQuantity: "Nhập số lượng",
        replacementDate: "Ngày thay thế",
        returnDate: "Ngày trả hàng",
        chooseCustomer: "Chọn khách hàng",
        additionalNotes: "Thêm ghi chú bổ sung...",
        replacementProducts: "Sản phẩm thay thế",
        addProducts: "Thêm sản phẩm khác",
        tapSelect: "Chạm để chọn từ sản phẩm có sẵn",
        currently: "Hiện tại",
        item: "mặt hàng",
        items: "mặt hàng",
        selected: "đã chọn",
        selectedItems: "Mặt hàng đã chọn",
        hideDetails: "Ẩn chi tiết thêm",
        showDetails: "Hiển thị chi tiết thêm",
        product: "sản phẩm",
        priceLevel: "Chọn mức giá",
        customPrice: "Nhập giá tùy chỉnh",
        noReplaceHistory: "Không tìm thấy lịch sử thay thế",
        replaceReturn: "Thay thế và Hoàn trả",
        replaceReturnHistory: "Lịch sử Thay thế & Hoàn trả"
    },
    OtherComponent: {
        mfgHistoryTitle: "Lịch sử sản xuất",
        mfgHistoryDesc: "Theo dõi các sản phẩm kho đã sản xuất",
        dailyOperation: "Hoạt động hàng ngày",
        freqUsed: "Các hành động thường dùng để cập nhật hồ sơ nhanh chóng",
        manageCategory: "Quản lý danh mục",
        organizeCaterory: "Tổ chức và quản lý danh mục sản phẩm, chi phí và tài sản",
        businessRecord: "Hồ sơ kinh doanh",
        organizeRecord: "Tổ chức và quản lý hồ sơ kinh doanh của bạn",
        trackHistory: "Theo dõi lịch sử",
        completeTracking: "Lịch sử đầy đủ để kiểm toán và theo dõi",
        Verifyinventorycount: "Xác minh số lượng tồn kho",
        Exchangerates: "Tỷ giá hối đoái",
        Productiontracking: "Theo dõi sản xuất",
        Fixedassetregister: "Sổ đăng ký tài sản cố định",
        Storagelocations: "Vị trí lưu trữ",
        warehouseAvailability: 'Tính khả dụng của sản phẩm ở cấp độ kho',
        Logreviewspend: "Ghi nhật ký và xem xét chi tiêu",
        Productgroupings: "Nhóm sản phẩm",
        Classifyexpenditures: "Phân loại chi phí",
        Assetclassification: "Phân loại tài sản",
        Manageexchanges: "Quản lý trao đổi",
        Returnauditlog: "Nhật ký kiểm toán trả hàng",
        Interlocationmoves: "Di chuyển giữa các vị trí",
        Manageoperationscategoriesrecordsandhistory: "Quản lý hoạt động, danh mục, hồ sơ và lịch sử"
    },
    no_permission_dialog: {
        title: 'Không có quyền',
        historyDescription: "Bạn không có quyền xem Lịch sử Giao dịch. Vui lòng liên hệ quản trị viên của bạn.",
        replacementHistoryDescription: "Bạn không có quyền xem Lịch sử Thay thế & Trả hàng. Vui lòng liên hệ quản trị viên của bạn.",
        transferHistoryDescription: "Bạn không có quyền xem Lịch sử Chuyển kho. Vui lòng liên hệ quản trị viên của bạn."
    },
    OthersHistory: {
        title: "Quản lý Lịch sử",
        transferHistory: "Quản lý Lịch sử Chuyển",
        transactionHistory: "Quản lý Lịch sử Giao dịch",
        replacementHistory: "Quản lý Lịch sử Thay thế và Trả hàng"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Duyệt và mua các sản phẩm do doanh nghiệp chia sẻ.",
        description: "Duyệt các sản phẩm do doanh nghiệp chia sẻ.",
        productsAvailable: "Sản phẩm có sẵn",
        noImageAvailable: "Không có hình ảnh",
        productDetails: "Chi tiết sản phẩm",
        inStock: "còn hàng",
        availableVariants: "Tùy chọn có sẵn",
        options: "tùy chọn",
        orders: "Đơn hàng"
        ,
        searchProducts: "Tìm kiếm sản phẩm...",
        noProductsFound: "Không tìm thấy sản phẩm",
        tryDifferentKeyword: "Thử tìm kiếm với từ khóa khác",
        variants: "Biến thể",
        stock: "Tồn kho",
        cart: "Giỏ hàng",
        products: "Sản phẩm",
        viewCart: "Xem giỏ hàng",
        backToProducts: "Quay lại sản phẩm",
        yourCart: "Giỏ hàng của bạn",
        clear: "Xóa",
        cartEmpty: "Giỏ hàng trống",
        cartEmptyDesc: "Duyệt danh mục và thêm sản phẩm bạn muốn đặt hàng.",
        browseProducts: "Duyệt sản phẩm",
        selectedItems: "Sản phẩm đã chọn",
        itemInCart: "sản phẩm trong giỏ",
        itemsInCart: "sản phẩm trong giỏ",
        customerDeliveryDetails: "Thông tin khách hàng & giao hàng",
        fullName: "Họ và tên",
        enterFullName: "Nhập họ và tên",
        deliveryAddress: "Địa chỉ giao hàng",
        addressPlaceholder: "Đường, tòa nhà, thành phố, mã bưu điện...",
        orderNote: "Ghi chú đơn hàng (Tùy chọn)",
        orderNotePlaceholder: "Hướng dẫn đặc biệt hoặc ghi chú giao hàng...",
        paymentMode: "Phương thức thanh toán",
        subtotal: "Tạm tính",
        items: "sản phẩm",
        totalAmount: "Tổng cộng",
        orderOnWhatsApp: "Đặt hàng qua WhatsApp 📲",
        orderPlaced: "Đặt hàng thành công! 🎉",
        orderPlacedDesc: "Đơn hàng đã được ghi nhận và WhatsApp đã mở.",
        continueShopping: "Tiếp tục mua sắm 🛍️",
        cartEmptyTitle: "Giỏ hàng trống",
        cartEmptyToast: "Vui lòng thêm sản phẩm trước khi thanh toán.",
        incompleteTitle: "Thông tin chưa đầy đủ",
        incompleteToast: "Vui lòng điền tất cả các trường bắt buộc.",
        nameRequired: "Họ và tên là bắt buộc",
        addressRequired: "Địa chỉ giao hàng là bắt buộc",
        catalogUnavailable: "Danh mục hiện không khả dụng",
        catalogUnavailableDesc: "Danh mục này hiện không hoạt động. Vui lòng liên hệ doanh nghiệp.",
        invalidCatalogLink: "Liên kết danh mục không hợp lệ 🚫",
        invalidCatalogDesc: "Trang danh mục này thiếu thông tin cần thiết.",
        missing: "Thiếu",
        catalogSlug: "Mã danh mục",
        goBackHome: "Về trang chủ",
        inventoryManagement: "Quản lý kho & Hóa đơn 🚀 Simply",
        enter: "Nhập",
        select: "Chọn",
        // Catalog Order translations
        catalogOrders: 'Đơn hàng danh mục',
        pending: 'Đang chờ xử lý',
        converted: 'Đã chuyển đổi',
        cancelled: 'Đã hủy',
        totalRevenue: 'Tổng giá trị',
        totalCatalogOrders: 'Tổng đơn hàng trực tuyến',
        convertToSalesOrder: 'Chuyển thành đơn bán hàng',
        date: 'Ngày',
        status: 'Trạng thái',
        action: 'Thao tác',
        searchOrders: 'Tìm khách hàng hoặc số điện thoại...',
        noMatchingOrders: 'Không tìm thấy đơn hàng phù hợp',
        noStatusOrders: 'Không tìm thấy đơn hàng {status}',
        tryDifferentSearch: 'Thử tìm kiếm với tên khách hàng hoặc số điện thoại khác.',
        noOrdersWithStatus: 'Hiện không có đơn hàng nào với trạng thái {status}.',
        noOrdersYet: 'Chưa có đơn hàng danh mục',
        noOrdersDescription: 'Các đơn hàng từ danh mục trực tuyến của bạn sẽ hiển thị tại đây.',
        guestCustomer: 'Khách vãng lai',
        item: 'Mặt hàng',
        moreItems: '+{count} nữa',
        viewDetails: 'Xem chi tiết',
        viewSalesOrder: 'Xem đơn bán hàng',
        cancelOrder: 'Hủy đơn hàng',
        confirmCancelTitle: 'Hủy đơn hàng danh mục?',
        confirmCancelOrder: 'Bạn có chắc chắn muốn hủy đơn hàng này không? Hành động này không thể hoàn tác.',
        keepOrder: 'Không, giữ đơn hàng',
        confirmCancelAction: 'Có, hủy đơn hàng',
        orderNotFound: 'Không tìm thấy đơn hàng danh mục',
        orderNotFoundDescription: 'Không thể tìm thấy đơn hàng này hoặc bạn có thể không có quyền xem.',
        backToCatalogOrders: 'Quay lại đơn hàng danh mục',
        placedOn: 'Đặt vào',
        totalItems: 'Tổng mặt hàng',
        orderedProducts: 'Sản phẩm đã đặt',
        itemDetails: 'Chi tiết mặt hàng',
        quantity: 'SL',
        unitPrice: 'Đơn giá',
        total: 'Tổng',
        variant: 'Biến thể',
        customerInformation: 'Thông tin khách hàng',
        additionalFields: 'Trường bổ sung',
        fields: 'trường',
    },
    stockNew: {
        Npay: "Chưa có sản phẩm nào được thêm",
        emptydesc: "Chọn một sản phẩm từ danh mục của bạn và nhập số lượng nhập vào để ghi nhận kho.",
        tipText: "Mẹo: Bạn cũng có thể tải lên tệp excel",
        OT: "Tổng đơn hàng",
        Collapse: "Thu gọn"
    },
    deleteBulk: {
        Bulkoperation: "Thao tác hàng loạt",
        Applyproducts: "Áp dụng hành động cho nhiều sản phẩm",
        Bulkupload: "Tải lên hàng loạt",
        ImportCSVfile: "Nhập sản phẩm qua file Excel hoặc CSV",
        or: "hoặc",
        Bulkdelete: "Xóa hàng loạt",
        Permanentlyallproducts: "Xóa vĩnh viễn tất cả sản phẩm",
        IrrText: "Xóa hàng loạt không thể hoàn tác. Xuất bản sao lưu trước nếu cần.",
        SeP: "Sản phẩm đã chọn",
        sP: "Chọn sản phẩm",
        DA: "Xóa tất cả",
        DP: "Xóa sản phẩm",
        sL: "Chọn tất cả",
        ASDE: "Bạn có chắc muốn xóa tất cả sản phẩm trừ",
        ASDAllP: "Bạn có chắc muốn xóa tất cả sản phẩm?",
        ASD: "Bạn có chắc muốn xóa",
        products: "sản phẩm",
        TACBU: "Hành động này không thể hoàn tác.",
        LP: "Đang tải sản phẩm...",
        FM: "Đang tải thêm...",
        NPF: "Không tìm thấy sản phẩm nào.",
        LMP: "Đang tải thêm sản phẩm..."
    },
    NewVariantModal: {
        Definevariantsassign: "Xác định biến thể & phân bổ số lượng",
        Nothingallocated: "Chưa phân bổ gì",
        Overallocated: "Phân bổ vượt quá",
        Fullyallocated: "Phân bổ đầy đủ",
        Overby: "Vượt quá",
        Allvariantsneedaname: "Tất cả biến thể cần có tên.",
        Reducequantities: "Giảm số lượng.",
        Overallocatedby: "Phân bổ vượt quá",
        Quantitiesmustmatchthetotalavailability: "Số lượng phải khớp với tổng số lượng có sẵn.",
        Allocatequantitiesacrosswarehouses: "Phân bổ số lượng qua các kho",
        Notfullydistributed: "Chưa phân bổ đầy đủ:",
        remaining: "còn lại",
        Qty: "SL",
        Inactive: "Không hoạt động",
        left: "còn lại"
    },
    ProductFormNew: {
        BasicInfo: "Thông tin cơ bản",
        ProductImage: "Hình ảnh sản phẩm",
        Images: "Hình ảnh",
        Pricing: "Giá bán",
        Everypriceneedsbothalabelandanamount: "Mỗi mức giá cần cả nhãn và số tiền",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Thêm nhãn như "Bán sỉ" hoặc "Bán lẻ" để xác định mức giá này',
        AddMultiplePrice: "Thêm nhiều mức giá",
        NoPhotosLetAiFind: "Không có ảnh? Để AI tìm hình ảnh sản phẩm",
        AddProductImagesTitle: "Thêm hình ảnh sản phẩm",
        ChooseHowToAddPhotos: "Chọn cách bạn muốn thêm ảnh cho sản phẩm này:",
        SearchWithAi: "Tìm kiếm bằng AI",
        SearchWithAiDesc: "Tự động tìm & chọn hình ảnh sản phẩm bằng AI",
        FilesFileExplorer: "Tệp (Trình duyệt tệp)",
        FilesFileExplorerDesc: "Chọn hình ảnh trực tiếp từ máy tính của bạn",
        AiProductImageFinder: "Công cụ tìm ảnh sản phẩm bằng AI",
        AiProductImageFinderDesc: "Tìm kiếm & chọn hình ảnh cho sản phẩm của bạn",
        TypeProductNamePlaceholder: "Nhập tên sản phẩm...",
        SearchForYourProduct: "Tìm kiếm sản phẩm của bạn",
        SearchForYourProductHint: `Thử tên thương hiệu hoặc sản phẩm, ví dụ: "Kirkland Minoxidil"`,
        ImagesSelected: "hình ảnh đã chọn",
        AddSelected: "Thêm mục đã chọn"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Xác định trường tùy chỉnh mới",
        AttributeName: "Tên thuộc tính",
        DataType: "Kiểu dữ liệu",
        Noattributesfound: "Không tìm thấy thuộc tính nào",
        ManageAttributes: "Quản lý thuộc tính",
        Editordeleteexistingattributes: "Chỉnh sửa hoặc xóa thuộc tính hiện có",
        UpdateAttribute: "Cập nhật thuộc tính",
        Saving: "Đang lưu..."
    },
    NewExpenses: {
        Noexpensesyet: "Chưa có chi tiêu nào",
        Addyourfirstexpensetostarttrackingyourspending: "Thêm chi tiêu đầu tiên của bạn để bắt đầu theo dõi chi tiêu.",
        TOTALEXPENSES: "TỔNG CHI TIÊU",
        ENTRIES: "MỤC NHẬP",
        BYCATEGORY: "THEO DANH MỤC",
        Nocategoriestodisplay: "Không có danh mục để hiển thị",
        DateanfTime: "Ngày & Giờ"
    },
    PurchaseSales: {
        CancelOrder: "Hủy đơn hàng",
        ReopenOrder: "Mở lại đơn hàng",
        Reopen: "Mở lại",
        ConfirmCancelOrder: "Bạn có chắc chắn muốn hủy đơn hàng này không?",
        ConfirmReopenOrder: "Bạn có chắc chắn muốn mở lại đơn hàng này không?",
        OrderCancelledSuccessfully: "Đơn hàng đã được hủy thành công.",
        OrderReopenedSuccessfully: "Đơn hàng đã được mở lại thành công.",
        CancelledBy: "Hủy bởi",
        Cancelled: "Đã hủy",
        ConvertPriceBasedOnUnitConversion: "Chuyển đổi giá theo quy đổi đơn vị",
        MarkPaymentAsPending: "Đánh dấu khoản thanh toán đang chờ xử lý",
        PendingReceivableDesc: "Số tiền được ghi nhận là khoản phải thu. Ghi nhận thanh toán khi nhận được.",
        PendingPayableDesc: "Số tiền được ghi nhận là khoản phải trả. Ghi nhận thanh toán khi đã trả.",
        SelectCustomerFirst: "Vui lòng chọn khách hàng trước",
        SelectSupplierFirst: "Vui lòng chọn nhà cung cấp trước",
        SelectItemsFirst: "Vui lòng chọn ít nhất một mặt hàng trước",
        PaymentMarkedPendingDesc: "Khoản thanh toán được đánh dấu là đang chờ xử lý. Bỏ chọn 'Đánh dấu khoản thanh toán đang chờ xử lý' để ghi nhận thanh toán ngay.",
        SelectCustomerAndItemFirst: "Vui lòng chọn khách hàng và ít nhất một mặt hàng trước",
        SelectSupplierAndItemFirst: "Vui lòng chọn nhà cung cấp và ít nhất một mặt hàng trước",
        SelectCustomerProductFirst: "Chọn khách hàng và sản phẩm trước",
        SelectSupplierProductFirst: "Chọn nhà cung cấp và sản phẩm trước",
        Receivables: "Phải Thu",
        Payables: "Phải Trả",
        AccessDenied: "Truy cập bị từ chối",
        YouDonthaeP: "Bạn không có quyền xem trang này. Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ với quản trị viên của bạn.",
        purchase: "Mua hàng",
        sales: "Bán hàng",
        Areyousureyouwantto: "Bạn có chắc chắn muốn",
        Thisactionwillupdateitsstatus: "Hành động này sẽ cập nhật trạng thái của nó.",
        ReasonOPtional: "Lý do (Tùy chọn)",
        Enterareasonfor: "Nhập lý do cho",
        optionalDot: "(tùy chọn)...",
        Reject: "Từ chối",
        ConfirmOrder: "Xác nhận đơn hàng",
        RejectOrder: "Từ chối đơn hàng",
        Previous: "Trước",
        First: "Đầu tiên",
        Order: "Đơn hàng",
        Items: "Mặt hàng",
        Memo: "Ghi chú",
        SelectDateRange: "Chọn khoảng thời gian",
        List: "Danh sách",
        Board: "Bảng",
        View: "Xem",
        CreateSalesOrder: "Tạo đơn bán hàng",
        CreatePurchaseOrder: "Tạo đơn mua hàng",
        successfully: "thành công",
        ManageAttachments: "Quản lý tệp đính kèm",
        Stockoutitemsimmediatelyaftersaving: "Xuất kho ngay sau khi lưu.",
        Stockinitemsimmediatelyaftersavingthisorder: "Nhập kho ngay sau khi lưu đơn hàng này.",
        ViewAttachments: "Xem tệp đính kèm",
        MemoAttachments: "Ghi chú & Tệp đính kèm",
        ReceivedDate: "Ngày nhận",
        ShippedDate: "Ngày giao hàng",
        OrderDate: "Ngày đặt hàng",
        OrderDetails: "Chi tiết đơn hàng",
        Subtotal: "Tổng phụ",
        OrderSummary: "Tóm tắt đơn hàng",
        AddItem: "Thêm mặt hàng",
        NewSalesOrder: "Đơn bán hàng mới",
        NewPurchaseOrder: "Đơn mua hàng mới",
        Createandmanageyour: "Tạo và quản lý",
        orders: "đơn hàng của bạn",
        Removeitem: "Xóa mặt hàng",
        UnitPrice: "Đơn giá",
        PurchaseOrder: "Đơn mua hàng",
        SalesOrder: "Đơn bán hàng",
        PurchaseInvoice: "Hóa đơn mua hàng",
        SalesInvoice: "Hóa đơn bán hàng",
        PurchaseOrdernotfound: "Không tìm thấy đơn mua hàng",
        Approve: "Phê duyệt",
        MarkasShipped: "Đánh dấu đã giao hàng",
        MarkasReceived: "Đánh dấu đã nhận",
        Marking: "Đang đánh dấu...",
        PartiallyShip: "Giao hàng một phần",
        PartiallyReceive: "Nhận một phần",
        Deleting: "Đang xóa...",
        Transaction: "Giao dịch",
        Details: "Chi tiết",
        Item: "Mặt hàng",
        Received: "Đã nhận",
        Shipped: "Đã giao",
        Ordered: "Đã đặt",
        units: "đơn vị",
        Overalldiscount: "Chiết khấu tổng",
        Transactions: "Giao dịch",
        Notransactionsfound: "Không tìm thấy giao dịch",
        OrderedQty: "Số lượng đặt",
        Totalqty: "Tổng số lượng",
        StockingOut: "Đang xuất kho...",
        StockingIn: "Đang nhập kho...",
        thiorderUpdateStuau: "đơn hàng này? Hành động này sẽ cập nhật trạng thái.",
        TransactionDetails: "Chi tiết giao dịch",
        Fetchingtransactiondetails: "Đang lấy chi tiết giao dịch...",
        Nodetailsfoundforthistransaction: "Không tìm thấy chi tiết cho giao dịch này.",
        TotalBreakDown: "Phân tích tổng",
        ChangeAmount: "Số tiền thừa",
        Attachments: "Tệp đính kèm",
        PoNumber: "Số PO",
        SoNumber: "Số SO",
        partner: "Đối tác",
        EditPurchase: "Chỉnh sửa mua hàng",
        EditSales: "Chỉnh sửa bán hàng",
        PurchaseOrderDetails: "Chi tiết đơn mua hàng",
        SalesOrderDetails: "Chi tiết đơn bán hàng",
        OrderType: "Loại đơn hàng",
        SelectOrderType: "Chọn loại đơn hàng",
        OrderTypePrepaid: "Trả trước",
        OrderTypeCOD: "Thanh toán khi nhận hàng",
        OrderTypePayLater: "Thanh toán sau",
        OrderTypePartialPayment: "Thanh toán một phần",
        OrderTypeSubscription: "Đăng ký thuê bao",
        viewAvailabilty: 'Xem lịch trống',
        NotReceived: "Chưa nhận",
        NotShipped: "Chưa giao",
        PartiallyReceived: "Đã nhận một phần",
        PartiallyShipped: "Đã giao một phần",
    },
    PriceReference: {
        HighPrice: "Giá Cao",
        LowPrice: "Giá Thấp",
        LastPrice: "Giá Cuối Cùng",
        LastPurchasePrice: "Giá mua gần nhất",
        Nopricerecordsfound: "Không tìm thấy hồ sơ giá",
        BuyingPriceReference: "Tham chiếu Giá Mua",
        SellingPriceReference: "Tham chiếu Giá Bán",
        Viewstockinpricesfortheselectedvendorandproduct: "Xem giá nhập kho cho nhà cung cấp và sản phẩm đã chọn",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Xem giá xuất kho cho khách hàng và sản phẩm đã chọn"
    },
    SubscriptionLocale: {
        premiumPlan: "Gói Premium",
        heading: "Ra quyết định kinh doanh",
        headingHighlight: "Dựa trên dữ liệu",
        subtitle: "Mở khóa toàn bộ sức mạnh của phân tích kinh doanh — không giới hạn, không thỏa hiệp.",
        choosePlan: "Chọn gói của bạn",
        monthly: "Hàng tháng",
        annual: "Hàng năm",
        oneTime: "Một Lần (Hàng tháng)",
        perMonth: "mỗi tháng",
        perYear: "mỗi năm",
        bestValue: "Giá trị tốt nhất",
        continueWith: "Tiếp tục với",
        perMonthShort: "tháng",
        perYearShort: "năm",
        troubleWithSubscription: "Gặp vấn đề với đăng ký?",
        contactUs: "Liên hệ chúng tôi",
        paymentNotReady: "Thanh toán chưa sẵn sàng",
        checkoutError: "LỖI THANH TOÁN",
        pricePreviewError: "LỖI XEM TRƯỚC GIÁ",
        subNotAvailable: "Không có gói đăng ký",
        subNotAvailableDesc: "Các gói đăng ký trên web hiện không khả dụng tại quốc gia của bạn. Vui lòng đăng ký qua ứng dụng di động của chúng tôi hoặc liên hệ với chúng tôi để được hỗ trợ."
    },
    SubscriptionLocale2: {
        GoPro: "Nâng cấp lên Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Ra quyết định thông minh hơn được hỗ trợ bởi dữ liệu kinh doanh thực tế",
        ExploreProPlans: "Khám phá các gói Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Bạn có thể có nhiều kho cho các vị trí vật lý khác nhau",
            "Mỗi sản phẩm theo dõi tồn kho theo từng kho một cách độc lập",
            'Sử dụng "Chuyển kho" để di chuyển tồn kho giữa các vị trí'
        ],
        NoWarehousesConfigured: "Chưa có kho nào được cấu hình",
        desc: "Bắt đầu bằng cách thêm kho của bạn (nếu có nhiều hơn một), sau đó thêm sản phẩm và ghi nhận các chuyển động tồn kho.",
        WarehouseSetupTips: "Mẹo thiết lập kho",
        Noproductselected: "Chưa chọn sản phẩm nào",
        Selectaproductfromthelefttoviewlowstockdetails: "Chọn một sản phẩm từ bên trái để xem chi tiết tồn kho thấp.",
        Chooseaproductfromthelist: "Chọn một sản phẩm từ danh sách",
        SelectProduct: "Chọn sản phẩm",
        SetQuantity: "Đặt số lượng",
        Showing: "Đang hiển thị",
        products: "sản phẩm",
        Continue: "Tiếp tục",
        SaveSafetyStock: "Lưu tồn kho an toàn",
        SafetyStockSaved: "Đã lưu tồn kho an toàn!",
        hasbeensetto: "đã được đặt thành",
        AddAnother: "Thêm cái khác",
        Chooseaproduct: "Chọn một sản phẩm",
        Step: "Bước",
        of: "trong",
        Setsafetyquantity: "Đặt số lượng an toàn",
        Complete: "Hoàn tất",
        SafetyStockQuantity: "Số lượng tồn kho an toàn",
        Minimumunitsdropsbelowthisnumber: "Số đơn vị tối thiểu luôn giữ trong kho. Cảnh báo sẽ kích hoạt khi tồn kho giảm xuống dưới số này.",
        NewSafetyStock: "Tồn kho an toàn mới",
        SafetyNow: "An toàn hiện tại",
        SettingTo: "Đang đặt thành",
        Change: "Thay đổi",
        sell: "bán",
        cost: "chi phí",
        BulUD: "Tải lên/Xóa hàng loạt"
    },
    SimplyLoginUI: {
        sslEncryption: "Mã hóa SSL 256-bit",
        dataPrivate: "Dữ liệu của bạn được bảo mật 100%",
        worksOnDevices: "Hoạt động trên Android & iPhone",
        realTimeSync: "Đồng bộ thời gian thực trên tất cả thiết bị",
        cloudBackup: "Sao lưu đám mây tự động",
        availableOn: "Có sẵn trên Web, Android & iOS",
        tagline: "Kho hàng của bạn,",
        taglineEm: "đẹp và đơn giản.",
        subtitle: "Đăng nhập để quản lý tồn kho, theo dõi bán hàng và vận hành kinh doanh — tất cả trong một nơi.",
        feature1Title: "Theo dõi tồn kho thời gian thực",
        feature1Desc: "Biết chính xác những gì đang có trong từng kho, luôn được cập nhật.",
        feature2Title: "Đơn hàng bán và mua",
        feature2Desc: "Tạo hóa đơn, quản lý nhà cung cấp và theo dõi mọi giao dịch.",
        feature3Title: "Báo cáo thông minh",
        feature3Desc: "Báo cáo tài chính, tồn kho và chuyển động hàng ngày chỉ trong một cái nhìn.",
        feature4Title: "Đồng bộ thời gian thực trên tất cả thiết bị",
        feature4Desc: "Thay đổi trên điện thoại xuất hiện ngay lập tức trên web — và ngược lại.",
        rating1: "Được đánh giá",
        rating2: "4.9/5",
        rating3: "bởi 10.000 doanh nghiệp bán buôn",
        brandName: "Simply",
        greeting: "Xin chào trở lại! 👋",
        noPasswordNeeded: "Đăng nhập để truy cập kho hàng của bạn — Android, iPhone & web, tất cả đều đồng bộ.",
        badge1: "Quản lý Tồn kho",
        badge2: "Theo dõi Bán hàng",
        badge3: "Báo cáo",
        trustEncryptedTitle: "Đã mã hóa",
        trustEncryptedSub: "SSL 256-bit",
        trustPrivateTitle: "Riêng tư",
        trustPrivateSub: "Chỉ dữ liệu của bạn",
        trustBackedTitle: "Đã sao lưu",
        trustBackedSub: "Tự động hàng ngày",
        availableOnLabel: "CÓ SẴN TRÊN",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Tất cả thiết bị đồng bộ ngay lập tức theo thời gian thực",
        securityNote: "100% an toàn.",
        securityDesc: "Mã hóa cấp ngân hàng bảo vệ toàn bộ dữ liệu của bạn. Chúng tôi chỉ đọc tên và email của bạn — không gì khác, không bao giờ.",
        signingIn: "Đang đăng nhập…",
        termsPrefix: "Khi đăng nhập, bạn đồng ý với",
        privacyPolicy: "Chính sách Bảo mật",
        and: "và",
        termsOfService: "Điều khoản Dịch vụ",
        google: "Đăng nhập bằng Google"
    },
    BatchLocal: {
        BatchName: "Tên Batch",
        EnterBatchName: "Nhập tên batch",
        EnterNotes: "Nhập ghi chú",
        ExpiredDate: "Ngày hết hạn",
        Selectexpireddate: "Chọn ngày hết hạn",
        BatchStatus: "Trạng thái Batch",
        CreatedDate: "Ngày tạo",
        Areyousureyouwanttodeletethisbatch: "Bạn có chắc chắn muốn xóa batch này không?",
        Youhavencreatedanybatchforthisproduct: "Bạn chưa tạo batch nào cho sản phẩm này.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Tạo batch đầu tiên của bạn để bắt đầu theo dõi tồn kho theo lô và ngày hết hạn.",
        Nobatchesyet: "Chưa có batch nào",
        Whatisbatchmanagement: "Quản lý batch là gì?",
        Howithelpsyourbusiness: "Nó giúp ích cho kinh doanh của bạn như thế nào",
        Trackbylotnumber: "Theo dõi theo số lô",
        Trackbylotnumberdesc: "Nhóm tồn kho theo lô của nhà sản xuất để bạn luôn biết đơn vị đến từ lô nào.",
        Expirydatecontrol: "Kiểm soát ngày hết hạn",
        Expirydatecontroldesc: "Nhận cảnh báo trước khi tồn kho hết hạn. Bán lô cũ trước và tự động giảm lãng phí.",
        Fulltraceability: "Khả năng truy xuất hoàn toàn",
        Fulltraceabilitydesc: "Xem chính xác lô nào được sử dụng trong mỗi giao dịch — rất tốt cho kiểm toán và thu hồi.",
        Supplierwisestock: "Tồn kho theo nhà cung cấp",
        Supplierwisestockdesc: "Tách tồn kho từ các nhà cung cấp khác nhau ngay cả với cùng một sản phẩm. So sánh chất lượng theo từng lô.",
        Createyourfirstbatchbutton: "Tạo batch đầu tiên của bạn",
        Nomatchesfound: "Không tìm thấy kết quả phù hợp",
        NomatchesfounddescBefore: "Chúng tôi không tìm thấy batch nào khớp với ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Xóa tìm kiếm",
        Nohistoryfoundthisbatch: "Không tìm thấy lịch sử cho batch này",
        ComprehensiveDetails: "Chi tiết toàn diện",
        History: "Lịch sử",
        InBatch: "Trong Batch",
        Noproductfoundinthisbatch: "Không tìm thấy sản phẩm nào trong batch này",
        SelectBatch: "Chọn Batch",
        available: "có sẵn",
        Searchbatches: "Tìm kiếm batch...",
        Expires: "Hết hạn",
        Nobatchesfound: "Không tìm thấy batch nào",
        ManageBatches: "Quản lý Batch",
        Batchmanagement: "Quản lý Batch",
        Trackstockexpiry: "Theo dõi tồn kho theo batch và ngày hết hạn",
        Turnoffbatchmanagement: "Tắt quản lý batch?",
        Yourgsafe: "Dữ liệu batch hiện có của bạn vẫn an toàn.",
        Reenableanytimefrom: "Bạn có thể bật lại bất cứ lúc nào từ",
        Otherstab: "tab Khác",
        AddBatch: "Thêm Batch",
        Total: "Tổng",
        AssignProduct: "Gán Sản phẩm",
        EditProductAssignment: "Chỉnh sửa gán sản phẩm",
        AssignProducttoBatch: "Gán sản phẩm vào batch",
        Updateproductconfiguration: "Cập nhật cấu hình sản phẩm",
        Step1of2: "Bước 1 của 2",
        Step2of2: "Bước 2 của 2",
        Selectvariantwarehouse: "Chọn biến thể và kho",
        SelectedProduct: "Sản phẩm đã chọn",
        AssignQuantity: "Gán số lượng",
        BatchInfo: "Thông tin Batch",
        Wecouldnthisproductidentifier: "Chúng tôi không tìm thấy batch nào liên quan đến mã sản phẩm này.",
        NoActiveBatches: "Không có Batch đang hoạt động",
        Endofresults: "Kết thúc kết quả",
        Expiry: "Hết hạn",
        BatchManagementDescription: "Theo dõi kho theo số lô và ngày hết hạn. Đảm bảo trình tự LIFO / FEFO chính xác cho mỗi lần xuất kho — không cần chọn thủ công.",
        Expiryalerts: "Cảnh báo hết hạn",
        Autonotifications: "Thông báo tự động",
        LIFOsorting: "Sắp xếp LIFO / FEFO",
        Smartstockflow: "Luồng kho thông minh",
        Perout: "Xuất kho theo lô",
        Precisiontracking: "Theo dõi chính xác",
        NeedsReview: "Cần xem xét",
        Pending: "Đang chờ",
        Rejected: "Bị từ chối",
        Approved: "Đã duyệt",
        WaitingForApproval: "Đang chờ phê duyệt",
        WaitingForApprovalDesc: "Chủ sở hữu của bạn sẽ sớm xem xét và phê duyệt lô này.",
        BatchRejected: "Lô bị từ chối",
        BatchRejectedDesc: "Chủ sở hữu của bạn đã từ chối lô này.",
        Reason: "Lý do",
        Approve: "Phê duyệt",
        Reject: "Từ chối",
        ConfirmApproveTitle: "Phê duyệt lô",
        ConfirmRejectTitle: "Từ chối lô",
        ConfirmApprovalAction: "Bạn có chắc chắn muốn {action} lô này không? Hành động này sẽ cập nhật trạng thái của nó.",
        ReasonOptional: "Lý do (Tùy chọn)",
        EnterReasonPlaceholder: "Nhập lý do cho {action} (tùy chọn)",
        Processing: "Đang xử lý...",
        BatchActivatedSuccess: "Kích hoạt lô thành công",
        BatchDeactivatedSuccess: "Hủy kích hoạt lô thành công",
        BatchDeletedSuccess: "Xóa lô thành công",
        BatchApprovedSuccess: "Phê duyệt lô thành công",
        BatchRejectedSuccess: "Từ chối lô thành công",
        SearchByBatchName: "Tìm theo tên lô...",
        YesTurnOff: "Có, tắt",
        KeepItOn: "Giữ bật"
    },
    CategoryNewL: {
        TotalCategories: "Tổng số danh mục",
        lastaddedcategory: "danh mục được thêm cuối cùng",
        acrossalltypes: "trên tất cả các loại",
        MostRecent: "Gần đây nhất",
        YesD: "Có, Xóa",
        AllAssociated: "Tất cả các sản phẩm liên quan có thể bị ảnh hưởng"
    },
    OverDas: {
        movestockbetweenlocations: "Di chuyển hàng tồn kho",
        no_activity_yet: "Chưa có hoạt động nào",
        no_activity_sub: "Bán hàng, mua hàng, di chuyển hàng tồn kho và trả hàng sẽ xuất hiện ở đây theo thời gian thực.",
        make_first_sale: "Thực hiện lần bán hàng đầu tiên",
        add_stock: "Thêm hàng tồn kho",
        all_stock_healthy: "Tất cả mức tồn kho đều khỏe mạnh",
        all_stock_healthy_sub: "Không có mặt hàng nào sắp hết. Hãy thiết lập ngưỡng tối thiểu cho sản phẩm để nhận cảnh báo tại đây.",
        set_stock_thresholds: "Thiết lập ngưỡng tồn kho",
        no_warehouses_setup: "Chưa thiết lập kho hàng nào",
        no_warehouses_setup_sub: "Thêm một kho hàng để bắt đầu theo dõi hàng tồn kho được lưu trữ ở đâu và quản lý vị trí.",
        add_first_warehouse: "Thêm kho hàng đầu tiên",
        Customer: "Khách hàng",
        PurchasevsSales: "Mua hàng so với Bán hàng",
        Financialperformancechart: "Biểu đồ hiệu suất tài chính",
        QuickActions: "Hành động nhanh",
        Frequentlyused: "Thường xuyên sử dụng",
        Addinventory: "Thêm hàng tồn kho",
        Dispatchitems: "Gửi hàng",
        Addorder: "Thêm đơn hàng",
        Newitem: "Sản phẩm mới",
        Inventoryaccess: "Truy cập kho hàng",
        Itemsneedingreorder: "Sản phẩm cần đặt lại hàng",
        Latesttransactions: "Giao dịch gần đây",
        Operationalsummary: "Tóm tắt hoạt động",
        ViewAll: "Xem tất cả",
        Manage: "Quản lý",
        RecentActivity: "Hoạt động gần đây",
        LowStockAlerts: "Cảnh báo tồn kho thấp",
        Primary: "Chính",
        TotalWarehouses: "Tổng số kho hàng"
    },
    SerialLocal: {
        ShowOrHideFields: "Hiển thị hoặc ẩn các trường",
        ShowOrHideFieldsDesc: "Nhấn vào bất kỳ mục nào bên dưới để bao gồm hoặc xóa mục đó khỏi hóa đơn in. Các thay đổi sẽ được áp dụng ngay lập tức.",
        Manufacturesettings: "Cài đặt sản xuất",
        Showbuyingprice: "giá mua / chi phí sản phẩm",
        Showadditionalcost: "chi phí bổ sung",
        Costbreakdown: "Bản phân tích chi phí",
        Unitcost: "Chi phí đơn vị",
        Rawmaterialstotal: "Tổng nguyên liệu thô",
        Confirmentry: "Xác nhận nhập",
        SaveSerials: "Lưu số serial",
        SerialNumber: "Số serial",
        selected: "đã chọn",
        added: "đã thêm",
        Serialnumbers: "Số serial",
        ResetAll: "Đặt lại tất cả",
        Wecouldnfindthis: "Chúng tôi không tìm thấy số serial nào khả dụng cho sản phẩm này.",
        Nounitsfound: "Không tìm thấy đơn vị nào",
        Searchingserialnumbers: "Đang tìm kiếm số serial...",
        Scanorenterstock: "Quét hoặc nhập serial cho stock mới",
        Whataserialnumber: "Số serial là gì?",
        Auniqueidentifieryourinventorylifecycle: "Một mã định danh duy nhất cho mỗi đơn vị — cho phép bạn theo dõi từng món hàng riêng lẻ trong suốt vòng đời tồn kho.",
        Trackedstockout: "Xuất kho đã theo dõi",
        Chooseexactlyselected: "Chọn chính xác số serial nào đang rời đi. Chỉ hiển thị các serial đã nhập kho cho sản phẩm này — số lượng sẽ bị khóa sau khi bạn chọn ",
        SelectSerialstoout: " - Chọn serial để xuất kho",
        Thisinvoicegeneratedusingwwwsimplstockco: "Hóa đơn này được tạo bằng www.simplstock.co",
        AuthorizedSignature: "Chữ ký ủy quyền",
        Invoicesettings: "Cài đặt hóa đơn",
        Draw: "Vẽ",
        Taptoselectordeselectitems: "Nhấn để chọn hoặc bỏ chọn mục",
        Thissignaturewillbeadded: "Chữ ký này sẽ được thêm vào cuối hóa đơn in của bạn.",
        SignatureOptions: "Tùy chọn chữ ký",
        Upload: "Tải lên",
        DrawSignature: "Vẽ chữ ký",
        UploadSignature: "Tải chữ ký lên",
        Clear: "Xóa",
        ShowStaffName: "tên nhân viên",
        ShowSKU: "SKU",
        ShowBusinessName: "tên doanh nghiệp",
        ShowProductName: "tên sản phẩm",
        ShowBusinessPhoneNumber: "số điện thoại",
        ShowBusinessEmail: "email",
        ShowBusinessAddress: "địa chỉ",
        ShowProductImage: "hình ảnh sản phẩm",
        ShowPaymentDetails: "chi tiết thanh toán",
        ShowCategory: "danh mục",
        ShowVariant: "biến thể",
        ShowWarehouse: "kho hàng",
        ShowAttributes: "thuộc tính",
        ShowQuantity: "số lượng",
        ShowDiscount: "giảm giá",
        ShowTax: "thuế",
        ShowPrice: "giá",
        ShowTotalPrice: "tổng giá sản phẩm",
        ShowExpenses: "chi phí",
        ShowSignature: "chữ ký",
        ShowNote: "ghi chú",
        ShowSerialNumber: "số serial",
        Invoicesettingsapplied: "Đã áp dụng cài đặt hóa đơn. Kiểm tra hóa đơn để xem thay đổi.",
        EnterSerialNumber: "Nhập số serial",
        showAttachment: "tệp đính kèm"
    },
    FewLocal: {
        SelectBin: "Chọn Bin",
        Live: "Trực tiếp",
        Monitorinventorystocklevels: "Giám sát hàng tồn kho, di chuyển & mức tồn kho",
        StockControlCentre: "Trung tâm kiểm soát hàng tồn kho",
        Nochartdataavailable: "Không có dữ liệu biểu đồ",
        Disabled: "Đã tắt",
        Enabled: "Đã bật"
    },
    Bin: {
        Bin: "Bin",
        Add: "Thêm",
        NoBinsAddedYet: "Chưa có bin nào được thêm",
        BinLocationsHelp: "Vị trí bin giúp bạn theo dõi tồn kho theo vị trí chính xác bên trong kho này — không cần tìm kiếm nữa.",
        NameThemByPosition: "Đặt tên theo vị trí:",
        AddBinLocation: "Thêm vị trí bin",
        BinLocations: "vị trí bin",
        BinNameRequired: "Tên bin là bắt buộc",
        EditBin: "Chỉnh sửa bin",
        AddBin: "Thêm bin",
        EnterBinName: "Tên bin",
        EnterBinNamePlaceholder: "Nhập tên bin",
        BinStatus: "Trạng thái bin",
        BinNotes: "Ghi chú",
        EnterBinNotesPlaceholder: "Thêm một số ghi chú...",
        ViewInventory: "Xem hàng tồn kho",
        Inventory: "Hàng tồn kho",
        TrymatchingadifferentSKUname: "Thử với SKU hoặc tên khác.",
        Thisbinlocationcurrentlyempty: "Vị trí bin này hiện đang trống.",
        Loadingbins: "Đang tải bin...",
        bins: "bin",
        ManageBin: "Quản lý Bin",
        Print: "In",
        SBin: "Bin Nguồn",
        DBin: "Bin Đích"
    },
    WarehouseExcel: {
        title: "Tải lên Kho hàng & Vị trí Bin",
        description: "Hãy làm theo các bước dưới đây để tạo hàng loạt kho hàng cùng với vị trí bin bằng file Excel.",
        bulkUploadGuide: "Hướng dẫn tải lên hàng loạt",
        step1: "Bước 1",
        downloadTemplate: "Tải xuống mẫu Excel",
        downloadTemplateDesc: "Tải mẫu chính thức với tất cả tiêu đề cột cần thiết. Không đổi tên hoặc xóa bất kỳ cột nào.",
        downloadTemplateBtn: "Tải mẫu",
        step2: "Bước 2",
        fillExcelFile: "Điền vào file Excel",
        fillExcelDesc: "Mỗi hàng đại diện cho một kho hàng. Điền đầy đủ tất cả các cột — đối với vị trí bin, nhập tất cả tên bin cách nhau bằng dấu phẩy vào cột <code>Bin Names</code>.",
        step3: "Bước 3",
        thingsToKeepInMind: "Những điều cần lưu ý",
        rulesDesc: "Trước khi tải lên, hãy đảm bảo file của bạn tuân theo các quy tắc này.",
        step4: "Bước 4",
        uploadYourFile: "Tải lên file của bạn",
        uploadDesc: "Sau khi điền xong, tải file lên bên dưới. Hệ thống sẽ tự động tạo tất cả kho hàng và vị trí bin.",
        rules: ["Chỉ một hàng cho mỗi kho hàng", "Tên bin cách nhau bằng dấu phẩy trong một ô", "Không đổi tên tiêu đề cột", "Tên bin trùng lặp trong cùng kho sẽ bị bỏ qua", "Số điện thoại có mã quốc gia", "Chỉ chấp nhận file .xlsx hoặc .xls"],
        dropFileHere: "Kéo thả file Excel của bạn vào đây",
        supports: "Hỗ trợ .xlsx và .xls — tối đa 10 MB",
        chooseFileUpload: "Chọn File & Tải lên",
        parsing: "Đang phân tích file...",
        invalidFileType: "Loại file không hợp lệ. Vui lòng tải file Excel.",
        noData: "Không tìm thấy dữ liệu trong Excel",
        failedToRead: "Không thể đọc file Excel",
        unableToRead: "Không thể đọc file.",
        reviewTitle: "Xem lại dữ liệu kho hàng",
        reviewSubtitle: "Kiểm tra cuối cùng trước khi nhập vào hệ thống kinh doanh của bạn.",
        changeFile: "Đổi file",
        rowsFound: "hàng được tìm thấy",
        cancel: "Hủy",
        finalizeImport: "Hoàn tất & Nhập",
        importing: "Đang nhập...",
        success: "Thành công",
        allWarehouseUploadedSuccess: "Tất cả kho hàng đã được tải lên thành công",
        failed: "Thất bại",
        bulkUploadFailed: "Tải lên hàng loạt thất bại",
        error: "Lỗi",
        binNamesNote: "Trong cột <strong>Bin Names</strong>, nhập tất cả vị trí bin cho một kho hàng vào một ô duy nhất, cách nhau bằng dấu phẩy — ví dụ: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Tên kho hàng", email: "Email", phoneNumber: "Số điện thoại", location: "Vị trí", binNames: "Tên Bin" }
    },
    CustomerExcel: {
        title: "Tải lên Khách hàng",
        description: "Làm theo các bước dưới đây để tạo hàng loạt khách hàng bằng file Excel.",
        bulkUploadGuide: "Hướng dẫn tải lên hàng loạt",
        step1: "Bước 1",
        downloadTemplate: "Tải xuống mẫu Excel",
        downloadTemplateDesc: "Tải mẫu chính thức với tất cả tiêu đề cột được định cấu hình sẵn.",
        downloadTemplateBtn: "Tải mẫu",
        step2: "Bước 2",
        fillExcelFile: "Điền vào file Excel",
        fillExcelDesc: "Mỗi hàng đại diện cho một khách hàng. Điền đầy đủ tất cả các cột theo yêu cầu.",
        step3: "Bước 3",
        thingsToKeepInMind: "Những điều cần lưu ý",
        rulesDesc: "Trước khi tải lên, hãy đảm bảo file của bạn tuân theo các quy tắc này để tránh lỗi.",
        step4: "Bước 4",
        uploadYourFile: "Tải lên file của bạn",
        uploadDesc: "Sau khi điền xong, tải file lên bên dưới. Hệ thống sẽ tự động tạo tất cả khách hàng.",
        rules: [
            "Chỉ một hàng cho mỗi khách hàng",
            "Không đổi tên tiêu đề cột",
            "Số điện thoại có mã quốc gia",
            "Chỉ chấp nhận file .xlsx hoặc .xls"
        ],
        dropFileHere: "Kéo thả file Excel của bạn vào đây",
        supports: "Hỗ trợ .xlsx và .xls — tối đa 10 MB",
        chooseFileUpload: "Chọn File & Tải lên",
        parsing: "Đang phân tích file...",
        invalidFileType: "Loại file không hợp lệ. Vui lòng tải file Excel.",
        noData: "Không tìm thấy dữ liệu trong Excel",
        failedToRead: "Không thể đọc file Excel",
        unableToRead: "Không thể đọc file.",
        reviewTitle: "Xem lại dữ liệu khách hàng",
        reviewSubtitle: "Kiểm tra cuối cùng trước khi nhập vào hệ thống kinh doanh của bạn.",
        changeFile: "Đổi file",
        rowsFound: "hàng được tìm thấy trong file",
        cancel: "Hủy",
        finalizeImport: "Hoàn tất & Nhập",
        importing: "Đang nhập...",
        success: "Thành công",
        allCustomerUploadedSuccess: "Tất cả khách hàng đã được tải lên thành công",
        failed: "Thất bại",
        bulkUploadFailed: "Tải lên hàng loạt thất bại",
        error: "Lỗi",
        headers: {
            customerName: "Tên khách hàng",
            phoneNumber: "Liên hệ",
            address: "Địa chỉ",
            note: "Ghi chú"
        }
    },
    SupplierExcel: {
        title: "Tải lên Nhà cung cấp",
        description: "Làm theo các bước dưới đây để tạo hàng loạt nhà cung cấp bằng file Excel.",
        bulkUploadGuide: "Hướng dẫn tải lên hàng loạt",
        step1: "Bước 1",
        downloadTemplate: "Tải xuống mẫu Excel",
        downloadTemplateDesc: "Tải mẫu chính thức với tất cả tiêu đề cột được định cấu hình sẵn.",
        downloadTemplateBtn: "Tải mẫu",
        step2: "Bước 2",
        fillExcelFile: "Điền vào file Excel",
        fillExcelDesc: "Mỗi hàng đại diện cho một nhà cung cấp. Điền đầy đủ tất cả các cột theo yêu cầu.",
        step3: "Bước 3",
        thingsToKeepInMind: "Những điều cần lưu ý",
        rulesDesc: "Trước khi tải lên, hãy đảm bảo file của bạn tuân theo các quy tắc này để tránh lỗi.",
        step4: "Bước 4",
        uploadYourFile: "Tải lên file của bạn",
        uploadDesc: "Sau khi điền xong, tải file lên bên dưới. Hệ thống sẽ tự động tạo tất cả nhà cung cấp.",
        rules: [
            "Chỉ một hàng cho mỗi nhà cung cấp",
            "Không đổi tên tiêu đề cột",
            "Số điện thoại có mã quốc gia",
            "Chỉ chấp nhận file .xlsx hoặc .xls"
        ],
        dropFileHere: "Kéo thả file Excel của bạn vào đây",
        supports: "Hỗ trợ .xlsx và .xls — tối đa 10 MB",
        chooseFileUpload: "Chọn File & Tải lên",
        parsing: "Đang phân tích file...",
        invalidFileType: "Loại file không hợp lệ. Vui lòng tải file Excel.",
        noData: "Không tìm thấy dữ liệu trong Excel",
        failedToRead: "Không thể đọc file Excel",
        unableToRead: "Không thể đọc file.",
        reviewTitle: "Xem lại dữ liệu nhà cung cấp",
        reviewSubtitle: "Kiểm tra cuối cùng trước khi nhập vào hệ thống kinh doanh của bạn.",
        changeFile: "Đổi file",
        rowsFound: "hàng được tìm thấy trong file",
        cancel: "Hủy",
        finalizeImport: "Hoàn tất & Nhập",
        importing: "Đang nhập...",
        success: "Thành công",
        allSupplierUploadedSuccess: "Tất cả nhà cung cấp đã được tải lên thành công",
        failed: "Thất bại",
        bulkUploadFailed: "Tải lên hàng loạt thất bại",
        error: "Lỗi",
        headers: {
            supplierName: "Tên nhà cung cấp",
            phoneNumber: "Liên hệ",
            bankName: "Tên ngân hàng",
            accountHolderName: "Tên chủ tài khoản",
            accountNumber: "Số tài khoản",
            note: "Ghi chú"
        }
    },
    VariantTemplate: {
        VariantTemplates: "Mẫu Biến Thể",
        Managereusablevariantpatterns: "Quản lý mẫu biến thể có thể tái sử dụng",
        BinTransferHistory: "Lịch sử chuyển Bin",
        Trackmovementsacrossbins: "Theo dõi di chuyển giữa các bin",
        SerialNumberHistory: "Lịch sử Số Seri",
        Trackproductserialnumberactivity: "Theo dõi hoạt động số seri sản phẩm",
        Period: "Thời gian",
        Nohistoryfound: "Không tìm thấy lịch sử",
        Searchserialnumbers: "Tìm số seri...",
        SerialNumbersHistory: "Lịch sử Số Seri",
        Serialnumberhistoryglance: "Lịch sử số seri nhanh chóng.",
        Noserialnumbersfound: "Không tìm thấy số seri",
        Noactivityhistoryfound: "Không tìm thấy lịch sử hoạt động",
        Statussetto: "Đã đặt trạng thái thành",
        Timeline: "Dòng thời gian",
        Managereusableproductvariantpatterns: "Quản lý mẫu biến thể sản phẩm có thể tái sử dụng.",
        DeleteTemplate: "Xóa Mẫu",
        Areyousureyouwanttemplate: "Bạn có chắc muốn xóa mẫu này không?",
        CreateNewTemplate: "Tạo Mẫu Mới",
        CreateTemplate: "Tạo Mẫu",
        EditTemplate: "Chỉnh sửa Mẫu",
        UnlimitedTemplates: "Mẫu không giới hạn",
        CreateAsManyTemplates: "Tạo bao nhiêu mẫu tùy ý — Quần áo, Giày dép, Điện tử và nhiều hơn.",
        PickWhileAddingProduct: "Chọn khi thêm sản phẩm",
        OpenTemplateLibrary: "Mở thư viện mẫu và chọn tên biến thể chỉ trong vài giây.",
        MixFromMultipleTemplates: "Kết hợp từ nhiều mẫu",
        SelectFromMultipleTemplates: "Chọn tên biến thể từ nhiều mẫu cho một sản phẩm — hoàn toàn linh hoạt.",
        EditAnytime: "Chỉnh sửa bất cứ lúc nào",
        RenameTemplatesAnytime: "Đổi tên mẫu, thêm hoặc xóa tên biến thể bất cứ khi nào catalog thay đổi.",
        StayConsistent: "Giữ tính nhất quán",
        SameVariantNamesAcrossAll: "Tên biến thể giống nhau trên tất cả sản phẩm. Không lỗi chính tả, không trùng lặp, không đoán mò.",
        BuildOnceUseEverywhere: "Tạo một lần, sử dụng mọi nơi",
        StopReEnteringVariantNames: "Ngừng nhập lại cùng tên biến thể cho mọi sản phẩm. Tạo một mẫu, gán tên biến thể và sử dụng lại ngay lập tức.",
        Updateexistingvariantcombinations: "Cập nhật tổ hợp biến thể hiện có",
        Definenewvariantcombinations: "Định nghĩa tổ hợp biến thể mới",
        TemplateName: "Tên Mẫu",
        AddVariantOptions: "Thêm Tùy Chọn Biến Thể",
        SmallMedium: "vd: Small, Medium...",
        VariantsList: "Danh sách Biến Thể",
        Nooptionsaddedyet: "Chưa có tùy chọn nào được thêm",
        SaveTemplate: "Lưu Mẫu",
        egSizesColorsetc: "vd: Kích cỡ áo thun, Màu sắc, v.v.",
        Pleaseentertemplatename: "Vui lòng nhập tên mẫu",
        Pleaseaddatleastonevariantoption: "Vui lòng thêm ít nhất một tùy chọn biến thể",
        Templateupdatedsuccessfully: "Đã cập nhật mẫu thành công",
        Templatecreatedsuccessfully: "Đã tạo mẫu thành công",
        Failedtosavetemplate: "Lưu mẫu thất bại",
        Transfer: "Chuyển",
        Editassignment: "Chỉnh sửa phân công",
        Updateproductdetailsinbin: "Cập nhật chi tiết sản phẩm dalam bin",
        Editinginbin: "Đang chỉnh sửa trong bin",
        ConfirmUpdate: "Xác nhận Cập nhật",
        ConfirmAssign: "Xác nhận Phân công",
        Assignanotherproduct: "Phân công sản phẩm khác",
        TransferBin: "Chuyển Bin",
        SourceBin: "Bin Nguồn",
        DestinationBin: "Bin Đích",
        SelectSourceBin: "Chọn Bin Nguồn",
        SelectDestinationBin: "Chọn Bin Đích",
        Unit: "Đơn vị",
        ManageVariant: "Quản lý Biến Thể",
        CreateSKUvariationsyourproduct: "Tạo biến thể SKU cho sản phẩm của bạn",
        Assigningvariationsto: "Đang gán biến thể cho",
        Novariantsaddedyet: "Chưa có biến thể nào được thêm",
        AddedVariants: "Biến Thể Đã Thêm",
        AddVariantsfromTemplate: "Thêm Biến Thể từ Mẫu",
        Pickatemplateandselectvariantnames: "Chọn mẫu và chọn tên biến thể",
        ChooseaTemplate: "Chọn Mẫu",
        Selectvariantnamestoadd: "Chọn tên biến thể để thêm",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Chọn mẫu để chọn tên biến thể. Bạn có thể thêm từ nhiều mẫu.",
        Loadingtemplates: "Đang tải mẫu...",
        Backtotemplates: "Quay lại danh sách mẫu",
        Selectallindividualadd: "Chọn tất cả hoặc chọn từng tên biến thể để thêm.",
        VariantNames: "Tên Biến Thể",
        MediaDescription: "Phương tiện & Mô tả",
        Addattachmentsandproductnotes: "Thêm tệp đính kèm và ghi chú sản phẩm",
        ProductMedia: "Phương tiện Sản phẩm"
    },
    AddProductGuide: {
        title: "Thêm số lượng ban đầu sau khi lưu",
        description: "Sản phẩm không có trường số lượng ở đây. Sau khi lưu, hãy sử dụng 'Stock In' để ghi nhận tồn kho ban đầu — với quyền kiểm soát hoàn toàn về vị trí và theo dõi.",
        steps: {
            quantity: { title: "Số lượng", sub: "Đặt số lượng tồn kho ban đầu" },
            binLocation: { title: "Vị trí Bin", sub: "Lối đi, kệ, tầng — ví dụ: A-01-03" },
            serialNumbers: { title: "Số serial", sub: "Theo dõi từng đơn vị riêng lẻ" },
            warehouse: { title: "Kho hàng", sub: "Được lưu trữ ở vị trí nào" },
            batchExpiry: { title: "Batch / Hạn sử dụng", sub: "Nhóm tồn kho theo số batch" }
        },
        actions: { close: "Đóng" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Không tìm thấy lệnh chuyển",
        Itemshistory: "Các mặt hàng bạn chuyển giữa các kho sẽ xuất hiện ở đây để theo dõi và lịch sử.",
        CreateTransfer: "Tạo chuyển khoản"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Chạm vào sản phẩm để Sản xuất",
        Selectproductfrombelow: "Chọn sản phẩm từ danh sách bên dưới",
        SetupANewProduct: "Thiết lập Sản phẩm Mới",
        DefineAProductAdditsrawmaterial: "Định nghĩa Sản phẩm & thêm nguyên liệu thô",
        ManufacturingSetup: "Thiết lập Sản xuất",
        Pickproducttodefineitsproductiondetails: "Chọn sản phẩm để định nghĩa chi tiết sản xuất",
        ConfigureManufacturing: "Cấu hình Sản xuất",
        SelectRawMaterial: "Chọn Nguyên liệu thô",
        NoRawMaterials: "Không có Nguyên liệu thô",
        Definecomponentsneededtoproduct: "Định nghĩa các thành phần cần thiết để sản xuất sản phẩm này.",
        NoAdditionalCosts: "Không có Chi phí bổ sung",
        Addlaboroverheadlogisticalcharges: "Thêm chi phí nhân công, quản lý hoặc hậu cần.",
        AddAdditionalCost: "Thêm Chi phí bổ sung",
        AddCost: "Thêm Chi phí",
        TotalPrice: "Tổng giá",
        SelectCharges: "Chọn Loại phí",
        EnterEstimatedCost: "Nhập chi phí ước tính",
        QtyRequried: "Số lượng yêu cầu",
        Manufacturing: "Sản xuất",
        Outputfinishedgoodsdestination: "Đích đến của thành phẩm",
        Manufacturingquantity: "Số lượng sản xuất",
        Storefinishedgoodsat: "Lưu trữ thành phẩm tại",
        Rawmaterials: "Nguyên liệu thô",
        StockSelection: "Lựa chọn Kho",
        AdditionalCosts: "Chi phí bổ sung",
        Quantityconsume: "Số lượng tiêu thụ",
        Totalmanufacturingcost: "Tổng chi phí sản xuất",
        Sumofrawmaterialcosts: "Tổng cộng tất cả chi phí nguyên liệu thô",
        CustomManufacturingCharge: "Phí Sản xuất Tùy chỉnh",
        Addextralikelaboroverheadrepairs: "Thêm chi phí phụ thêm như nhân công, quản lý hoặc sửa chữa.",
        CalculatedTotal: "Tổng cộng đã tính toán",
        AddRawMaterial: "Thêm Nguyên liệu thô",
        ConfigureRawMaterial: "Cấu hình Nguyên liệu thô",
        Thisoutputunit: "Đây là số lượng cơ bản cần thiết cho mỗi đơn vị đầu ra.",
        ChangeProduct: "Đổi Sản phẩm",
        AddtoList: "Thêm vào Danh sách",
        ManufacturedSuccessfully: "Đã sản xuất Thành công",
        Manufacture: "Sản xuất",
        EditDeleteHistory: "Lịch sử Sửa/Xóa",
        ManageOrder: "Quản lý Đơn hàng",
        ManageBatch: "Quản lý lô",
        Paymentnotavailablehere: "Thanh toán không khả dụng ở đây",
        Thisrecordisanorderorderitself: "Bản ghi này từ một đơn hàng. Thanh toán chỉ có thể được ghi lại từ chính đơn hàng đó.",
        Torecorpaymenttheorderthethere: "Để ghi thanh toán, hãy đến đơn hàng được liên kết và sử dụng tùy chọn <b>Ghi Thanh Toán</b> tại đó.",
        GotoOrder: "Đi đến đơn hàng"
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Đã thay thế bằng",
        Noreplacementhistoryfound: "Không tìm thấy lịch sử thay thế",
        Noreturnhistoryfound: "Không tìm thấy lịch sử trả hàng",
        Productbeingreturned: "Sản phẩm đang được trả lại",
        Required: "Bắt buộc",
        Selectreturnedproduct: "Chọn sản phẩm trả lại",
        Searchnamescanbarcode: "Tìm theo tên, SKU hoặc quét mã vạch",
        Browse: "Duyệt",
        Stockhandling: "Xử lý nhập kho",
        Stockinreturnedproduct: "Nhập kho sản phẩm trả lại",
        Ontoinventory: "Bật — mặt hàng trả lại sẽ được thêm lại vào kho",
        Offreturnedonly: "Tắt — mặt hàng sẽ chỉ được ghi nhận là đã trả lại",
        Usedrestock: "Được sử dụng để tính toán điều chỉnh lợi nhuận khi nhập kho lại",
        Willaddedbackconfirmation: "Sẽ được thêm lại vào kho sau khi xác nhận",
        Returnreason: "Lý do trả hàng",
        Optional: "Tùy chọn",
        SelectReason: "Chọn lý do",
        Additionalnotes: "Ghi chú bổ sung",
        Describeofcustomerexplanation: "Mô tả tình trạng mặt hàng trả lại, hư hỏng có thể thấy, giải thích của khách hàng...",
        Requiredmustfilledcontinue: "Các trường bắt buộc phải được điền để tiếp tục",
        Reviewdetailsbeforeconfirming: "Xem lại chi tiết trước khi xác nhận",
        Replacementproductwilldeductedinventoryconfirmation: "Sản phẩm thay thế sẽ được trừ khỏi kho của bạn sau khi xác nhận.",
        Choosereplacementproduct: "Chọn sản phẩm thay thế",
        Willdeductedfrominventoryconfirm: "Sẽ được trừ khỏi kho sau khi xác nhận",
        Thesewillattachedothereturnrecord: "Những hình ảnh này sẽ được đính kèm vào hồ sơ trả hàng",
        Replacementitem: "Mặt hàng thay thế",
        Addanotherproduct: "Thêm sản phẩm khác",
        Replacementproductwillbe: "Sản phẩm thay thế sẽ được",
        deducted: "trừ",
        fromyourinventoryconfirmation: "khỏi kho của bạn sau khi xác nhận.",
        productadjustedusingprice: "Sản phẩm trả lại sẽ được nhập kho lại và lợi nhuận được điều chỉnh bằng giá bán gốc.",
        Willloggedreturnedonlynotrestocked: "Sẽ chỉ được ghi nhận là đã trả lại — không nhập kho lại",
        Returnonly: "Chỉ trả hàng",
        Imagesofreturnedproduct: "Hình ảnh sản phẩm trả lại",
        Returnedproductwill: "Sản phẩm trả lại sẽ",
        not: "không",
        berestockedloggedreturnedonly: "được nhập kho lại — chỉ ghi nhận là đã trả lại.",
        AddImage: "Thêm hình ảnh",
        STOCKIN: "NHẬP KHO",
        LOGONLY: "CHỈ GHI NHẬN",
        ContinuetoReview: "Tiếp tục xem lại →",
        Confirmreplacement: "Xác nhận thay thế",
        Confirmreturn: "Xác nhận trả hàng",
        Filldetailsbelowproceed: "Điền chi tiết bên dưới để tiếp tục",
        Review: "Xem lại",
        editdetails: "chỉnh sửa chi tiết",
        Configurereturndetails: "Cấu hình chi tiết trả hàng",
        Configurereplacementdetails: "Cấu hình chi tiết thay thế",
        SelectSource: "Chọn nguồn",
        Returning: "Đang trả hàng",
        Replacement: "Thay thế",
        WalkCustomer: "Khách lẻ",
        RETURNEDPRODUCT: "SẢM PHẨM TRẢ LẠI",
        REPLACEMENTPRODUCT: "SẢN PHẨM THAY THẾ",
        STOCKOUT: "XUẤT KHO",
        Netinventoryimpact: "Tác động kho tịnh",
        Replacementitemcost: "Chi phí mặt hàng thay thế",
        Returneditemrestockvalue: "Giá trị nhập kho lại mặt hàng trả lại",
        PROFITINVENTORYSUMMARY: "TÓM TẮT LỢI NHUẬN & KHO",
        Inventoryaction: "Hành động kho",
        Valuededucted: "Giá trị bị trừ",
        Profitadjustment: "Điều chỉnh lợi nhuận",
        stockedout: " đã xuất kho",
        restocked: " đã nhập kho lại",
        Noaction: "Không hành động",
        Valuebeingreturned: "Giá trị đang trả lại",
        Willberestocked: "Sẽ được nhập kho lại",
        Willbe: "Sẽ được",
        logged: "ghi nhận",
        ON: "BẬT",
        OFF: "TẮT",
        Linked: "Đã liên kết",
        Pleaseselectreturnedproduct: "Vui lòng chọn một sản phẩm trả lại",
        Quantityrequired: "Số lượng là bắt buộc",
        Buyingpricerequired: "Giá mua là bắt buộc",
        Pleaseaddleastreplacementproduct: "Vui lòng thêm ít nhất một sản phẩm thay thế",
        Pleaseconfigurereturnedproductdetails: "Vui lòng cấu hình chi tiết sản phẩm trả lại",
        Pleaseselectcustomer: "Vui lòng chọn khách hàng",
        Returndateisrequired: "Ngày trả hàng là bắt buộc",
        Pleasefillallrequiredfields: "Vui lòng điền tất cả các trường bắt buộc",
        Wildeductedfrominventory: "Sẽ được trừ khỏi kho",
        Currentprice: "Giá hiện tại",
        Defectivedamaged: "Lỗi / hư hỏng",
        Wrongitemreceived: "Nhận được sản phẩm sai",
        Customerchangedmind: "Khách hàng đổi ý",
        Sizefitissue: "Vấn đề kích thước / vừa vặn",
        Notasdescribed: "Không đúng như mô tả",
        Other: "Khác",
        Originalsaleprice: "Giá bán gốc (điều chỉnh lợi nhuận)",
        Addedbackinventory: "Đã thêm lại vào kho",
        Notaddedinventory: "Không thêm vào kho",
        replacedwith: "thay thế bằng",
        deductedfrominventory: "khấu trừ khỏi kho",
        RETURNWITHSTOCKIN: "TRẢ HÀNG · CÓ STOCK-IN",
        RETURNNOSTOCKIN: "TRẢ HÀNG · KHÔNG STOCK-IN",
        MULTIPLEREPLACEMENTS: "NHIỀU LẦN THAY THẾ",
        SINGLEREPLACEMENT: "THAY THẾ ĐƠN LẺ",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "ĐÃ TRẢ · STOCK IN",
        REPLACEMENTSTOCKOUT: "THAY THẾ · STOCK OUT",
        Returnonlylogsthisentry: "Trả hàng chỉ ghi lại mục này —",
        nostockwillbeaddedorremoved: "không có kho nào được thêm vào hoặc bị loại bỏ",
        frominventory: "từ kho.",
        Whentousethis: "Khi nào sử dụng điều này:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Sử dụng Trả hàng vào cuối ngày để ghi lại các mặt hàng được gửi đi bán nhưng bị hỏng hoặc không thể sử dụng được khi trả về — các mặt hàng bạn muốn theo dõi nhưng không thể thêm lại vào kho.",
        Youcanviewallpastreturnentriesin: "Bạn có thể xem tất cả các mục trả hàng trước đây trong",
        ReturnHistory: "Lịch sử trả hàng",
        underthe: "dưới tab",
        Others: "Khác",
        tab: ".",
        Negativestocktransactiondisabled: "Giao dịch cổ phiếu âm đã bị vô hiệu hóa."
    },
    NewRLocal: {
        Originalsaleprice: "Giá bán gốc",
        Editinghistoryonlyinventorystaysunchanged: "Chỉ chỉnh sửa lịch sử — tồn kho không thay đổi.",
        Changeshereupdatethisdetailsquantitiesaffected: "Các thay đổi ở đây chỉ cập nhật chi tiết bản ghi này (lý do, ngày, ghi chú). Số lượng tồn kho thực tế, vị trí bin và dữ liệu sản phẩm của bạn không bị ảnh hưởng.",
        Needtofixinventorylevelsinstead: "Cần sửa mức tồn kho thay thế?",
        AdjustStock: "Điều chỉnh tồn kho",
        Refund: "Hoàn tiền",
        ImportantNote: "Ghi chú quan trọng",
        Pleasereviewbeforecontinuing: "Vui lòng xem lại trước khi tiếp tục",
        Onceshippedreceivedanyupdatesmadeorder: "Khi một đơn hàng đã được giao hoặc nhận, bất kỳ cập nhật nào được thực hiện cho đơn hàng sẽ không được phản ánh trong lịch sử giao dịch.",
        Thisundone: "Hành động này sẽ xóa vĩnh viễn đơn hàng. Hành động này không thể hoàn tác.",
        Inventorywilladjustedautomatically: "Tồn kho sẽ không được điều chỉnh tự động",
        Deletingthisreversevedshippedyouwillneed: "Xóa cái này không hoàn tác bất kỳ thay đổi kho nào. Nếu các mặt hàng đã được nhận/giao, bạn sẽ cần",
        reflectthecorrectstocklevels: "để phản ánh mức tồn kho chính xác.",
        manuallyadjustyourinventory: "điều chỉnh thủ công tồn kho của bạn",
        Addremovestockforitemsthatwereshipped: "Thêm/bớt kho cho các mặt hàng đã giao",
        Addremovestockforitemsthatwerereceived: "Thêm/bớt kho cho các mặt hàng đã nhận",
        Updatecostrecordspaymentwaalreadymade: "Cập nhật hồ sơ chi phí nếu thanh toán đã được thực hiện",
        Reconcilerecordsandoutstandingpayments: "Đối soát hồ sơ và các khoản thanh toán chưa giải quyết"
    },
    ReceivablesLocal: {
        Receivables: "Phải Thu",
        Manageandtrackcustomerduebalances: "Quản lý và theo dõi số dư phải thu của khách hàng",
        Viewcustomerduebalancereport: "Xem báo cáo số dư phải thu khách hàng",
        Viewsupplierduebalancereport: "Xem báo cáo số dư phải thu nhà cung cấp",
        DueBalance: "Số dư phải thu",
        Unpaid: "Chưa thanh toán",
        PartiallyPaid: "Thanh toán một phần",
        Paid: "Đã thanh toán",
        HighestBalance: "Số dư cao nhất",
        LowestBalance: "Số dư thấp nhất",
        Filldetailsrecordpayment: "Điền chi tiết để ghi nhận thanh toán",
        NewPaymentEntry: "Giao dịch thanh toán mới",
        EditPaymentEntry: "Chỉnh sửa giao dịch thanh toán",
        Nosuppliersfound: "Không tìm thấy nhà cung cấp",
        Nocustomersfound: "Không tìm thấy khách hàng",
        LowtoHigh: "Thấp đến Cao",
        HightoLow: "Cao đến Thấp",
        AttachmentUploadedSc: "Tải lên tệp đính kèm thành công",
        AttachmentUploadedF: "Tải lên tệp đính kèm thất bại",
        Pay: "Thanh toán",
        NoBillsFound: "Không tìm thấy hóa đơn",
        Thiscustomerhasunpaidbills: "Khách hàng này không có hóa đơn chưa thanh toán.",
        TotalDue: "Tổng phải thu",
        BillsFound: "Tìm thấy hóa đơn",
        DeselectAll: "Bỏ chọn tất cả",
        SelectAll: "Chọn tất cả",
        ShowDetails: "Hiển thị chi tiết"
    },
    AssetsNewLocal: {
        Assignedon: "Được cấp ngày",
        Total: "Tổng số",
        Assigned: "Đã cấp",
        Remaining: "Còn lại",
        Available: "Có sẵn",
        NoSerialNumbers: "Không có số sê-ri",
        UpdateExistingAssetDetails: "Cập nhật chi tiết tài sản hiện có",
        RegisterNewBusinessAsset: "Đăng ký tài sản kinh doanh mới",
        BasicInformation: "Thông tin cơ bản",
        AssetDetails: "Chi tiết tài sản",
        Quantity: "Số lượng",
        SerialNumbers: "Số sê-ri",
        SerialNumberPlaceholder: "Số sê-ri",
        AddSerialNumber: "Thêm số sê-ri",
        SerialNumbersOptional: "Số sê-ri là tùy chọn. Bạn có thể thêm tối đa",
        AssetImages: "Hình ảnh tài sản",
        AdditionalNotes: "Ghi chú thêm",
        AdditionalNotesPlaceholder: "Bất kỳ chi tiết bổ sung hoặc lịch sử bảo trì...",
        Updating: "Đang cập nhật...",
        Adding: "Đang thêm...",
        ITEquipmentPlaceholder: "vd: Thiết bị CNTT",
        LoadingMoreActivities: "Đang tải thêm hoạt động...",
        AssignedAssets: "Tài sản được giao",
        Noassetsassignedstaffmember: "Không có tài sản nào được giao cho nhân viên này.",
        Assignassetstaff: "Giao tài sản cho nhân viên",
        Returnassetfromstaff: "Trả lại tài sản này từ nhân viên",
        AssignmentDetails: "Chi tiết phân công",
        Serial: "Số serial",
        ViewAssets: "Xem Tất cả Tài sản",
        ViewByStaff: "Xem theo Nhân viên",
        AssignedHistory: "Lịch sử phân công",
        Returned: "Đã trả",
        Returnedon: "Trả vào ngày",
        ReturnedBy: "Trả bởi",
        AssignedTo: "Được giao cho",
        NoHistoryRecords: "Không có bản ghi lịch sử",
        Selectstaffmemberviewtheirassets: "Chọn một nhân viên để xem tài sản của họ",
        Deleted: "ĐÃ XÓA",
        searchPlaceholder: "Tìm tài sản theo tên hoặc số seri..."
    },
    InventoryCountLocale: {
        InventoryCount: "Kiểm kê hàng tồn kho",
        Viewinventorycountreport: "Xem báo cáo kiểm kê",
        ItemsCount: "Số lượng mặt hàng",
        All: "Tất cả",
        InProgress: "Đang thực hiện",
        Submitted: "Đã gửi",
        awaitingreview: "Đang chờ duyệt",
        EditInventoryCount: "Chỉnh sửa kiểm kê",
        NewInventoryCount: "Kiểm kê mới",
        Modifyinventorycountsheetdetails: "Chỉnh sửa chi tiết phiếu kiểm kê",
        Startanewinventorycountsheet: "Bắt đầu phiếu kiểm kê mới",
        GeneralInformation: "Thông tin chung",
        Title: "Tiêu đề",
        SaveChanges: "Lưu thay đổi",
        Selectproductsforthisinventorycountsheet: "Chọn sản phẩm cho phiếu này",
        InventoryCountDetails: "Chi tiết kiểm kê",
        Inventorycountsheetdetails: "Chi tiết phiếu kiểm kê",
        Viewingdetailsforcountsheet: "Đang xem chi tiết phiếu kiểm kê",
        Started: "Đã bắt đầu",
        TaskSheets: "Phiếu nhiệm vụ",
        Allitems: "Tất cả mặt hàng",
        NotStarted: "Chưa bắt đầu",
        Completed: "Hoàn thành",
        Results: "Kết quả",
        ViewResults: "Xem kết quả",
        DeleteInventoryCount: "Xóa kiểm kê",
        Viewingtransactionandadjustments: "Xem nhật ký giao dịch và điều chỉnh tồn kho",
        Productsadjusted: "Sản phẩm đã điều chỉnh",
        Assignee: "Người được giao",
        Tasksheetdetails: "Chi tiết phiếu nhiệm vụ",
        Draft: "Bản nháp",
        VariantQuantities: "Số lượng biến thể",
        AssignedProducts: "Sản phẩm được giao",
        ReturnAsset: "Trả Tài Sản",
        EditTasksheet: "Chỉnh sửa Phiếu Nhiệm Vụ",
        NewTasksheet: "Phiếu Nhiệm Vụ Mới",
        Updatetasksheetdetails: "Cập nhật chi tiết phiếu nhiệm vụ",
        Starttasksheetforthisinventorycount: "Bắt đầu phiếu nhiệm vụ mới cho kiểm kê này",
        TaskSheetInformation: "Thông Tin Phiếu Nhiệm Vụ",
        SheetTitle: "Tiêu Đề Phiếu",
        Entersheettitle: "Nhập tiêu đề phiếu",
        SubmissionResult: "Kết Quả Nộp",
        ReviewChanges: "Xem Lại Thay Đổi",
        Viewingsubmissionresultsforthisinventorycount: "Đang xem kết quả nộp cho kiểm kê này",
        Reviewyourinventorycountbeforesubmitting: "Xem lại kiểm kê trước khi nộp"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Không tải được số liệu kiểm kê",
        NoInventoryCounts: "Không Có Kiểm Kê",
        NoMatches: "Không Có Kết Quả",
        Therearenoinventorycountswiththestatus: "Không có kiểm kê nào có trạng thái",
        Noinventorycountsfoundyoursearchterm: "Không tìm thấy kiểm kê nào khớp với từ khóa tìm kiếm",
        Thereareinventorycountsrecordedyetforthisbusiness: "Chưa có kiểm kê hàng tồn kho nào được ghi nhận cho doanh nghiệp này"
    },
    StockinModalP: {
        StockInNow: "Nhập kho ngay",
        Settheopeningquantityforthisproductrightnow: "Đặt số lượng ban đầu cho sản phẩm này ngay bây giờ.",
        Addinitialstock: "Thêm tồn kho ban đầu?",
        dothislater: "Tôi sẽ làm sau",
        Productadded: "Đã thêm sản phẩm thành công!",
        isready: "đã sẵn sàng.",
        SeeHowItWorks: "Xem Cách Hoạt Động",
        NoSalesOrdersFound: "Không tìm thấy đơn hàng bán",
        NoPurchaseOrdersFound: "Không tìm thấy đơn hàng mua",
        Startcreatingoutgoinginventoryrevenue: "Bắt đầu tạo đơn hàng bán để theo dõi hàng xuất kho và doanh thu.",
        Trackrestockssupplierplace: "Theo dõi việc bổ sung hàng tồn kho và đơn hàng nhà cung cấp ở một nơi.",
        CreateSalesOrder: "Tạo Đơn Hàng Bán",
        CreatePurchaseOrder: "Tạo Đơn Hàng Mua",
    }
    ,
    dialy_report: "Báo Cáo Biến Động Hàng Ngày",
    Quotation: "Báo Giá",
    Quote: "Báo Giá",
    Assignee: "Người được giao",
    dayStart: "Bắt đầu ngày",

    ShowTotalAmount: "Tổng Số Tiền",


    tutorial: {
        watchTitle: 'Xem hướng dẫn từng bước',
        watchDesc: 'Tìm hiểu SimplyStock trên kênh YouTube của chúng tôi',
        modalTitle: 'Luôn đi trước với SimplyStock',
        modalDesc: 'Đăng ký để nhận hướng dẫn mới ngay khi họ thả xuống',
        feature1Title: 'Hướng dẫn về tính năng mới',
        feature1Sub: 'Mỗi bản cập nhật mới được giải thích bằng một video ngắn — vì vậy bạn không bao giờ bỏ lỡ những tính năng mới',
        feature2Title: 'Video hướng dẫn nhanh',
        feature2Sub: 'Thiết lập kho, hóa đơn, quyền truy cập của nhân viên và hơn thế nữa trong vòng chưa đầy 5 phút',
        feature3Title: 'Thông báo tức thì',
        feature3Sub: 'Nhận thông báo ngay khi có hướng dẫn mới — học theo tốc độ của riêng bạn',
        feature4Title: '100% miễn phí, luôn luôn',
        feature4Sub: 'Tất cả các hướng dẫn đều miễn phí vĩnh viễn — không cần đăng nhập hoặc đăng ký',
        subscribeBtn: 'Đăng ký SimplyStock',
        maybeLater: 'Có lẽ sau này'
    }
    ,
    dailyCashReport: {
        "title": "Báo cáo Tiền mặt Hàng ngày",
        "subtitle": "Ai đã trả khoản nào, ngày nào và còn nợ bao nhiêu — nhóm từ Chi tiết Bán hàng.",
        "totalSales": "Tổng doanh thu",
        "cashReceived": "Tổng Đã nhận",
        "outstanding": "Còn nợ",
        "collectionRate": "Tỷ lệ thu tiền",
        "grandTotalAllDates": "TỔNG CỘNG (tất cả các ngày)",
        "totalLabel": "Tổng",
        "loading": "Đang tải...",
        "noData": "Không tìm thấy dữ liệu cho khoảng thời gian đã chọn.",
        "loadingMore": "Đang tải thêm..."
    },
    dailyCashReportColumns: {
        "date": "Ngày",
        "customer": "Khách hàng",
        "productsSold": "Sản phẩm Đã bán",
        "products": "Sản phẩm",
        "salesAmount": "Doanh số",
        "sales": "Bán hàng",
        "received": "Tổng Đã nhận",
        "receivedShort": "Đã nhận",
        "debited": "Đã ghi nợ Sổ cái",
        "due": "Đến hạn",
        "paymentModes": "Phương thức Thanh toán",
        "mode": "Phương thức"
    }
}
export default vi
